/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-lonely-if */
// eslint-disable-next-line import/no-unresolved
import router from '@/router'
import axios from 'axios'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { mdiHomeOutline } from '@mdi/js'

require('moment/locale/es')

export default {
  logout() {
    sessionStorage.clear()
    router.push({ name: 'auth-login' })
  },
  GET_ABILITY({ ability }) {
    const permisos = sessionStorage.getItem('permisos_auth')
    if (permisos === '*') {
      return true
    }
    if (permisos.includes(ability)) {
      return true
    }

    return false
  },

  // ACTUALIZAR LOS PERMISOS DEL ROL O PERFIL AFILIADO
  getPerfilesAuth: state => {
    axios
      .get(`${process.env.VUE_APP_API_URL}profile`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
        },
      })
      .then(response => {
        // console.log(response.data.data.perfiles)
        // eslint-disable-next-line no-empty
        if (response.data.success === false) {
        } else {
          // console.log(response.data.data)
          state.userProfile = response.data.data
          state.perfilesAll = []
          state.perfilesAuth = []

          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < response.data.data.tableros.length; index++) {
            const element = response.data.data.tableros[index]
            if (element.active) {
              state.perfilesAuth.push({
                title: element.name,
                icon: mdiHomeOutline,
                to: { name: 'dashboard', params: { perfil: element.slug } },
                slug: element.slug,
                permiso: '',
                active: sessionStorage.getItem('perfil') === element.slug,
              })

              if (sessionStorage.getItem('perfil') === element.slug) {
                if (
                  response.data.data.id_father === null
                  || response.data.data.role.slug === 'super-admin'
                  || response.data.data.role.slug === 'superadmin'
                ) {
                  if (response.data.data.nivel === -1 || response.data.data.nivel === 0) {
                    if (response.data.data.nivel === -1) {
                      const permisos = element.permisos.abilities

                      // ONLY LEVEL SOPORT
                      permisos.push('exportation:list')

                      // permisos.push('nomenclators_countries:list')
                      sessionStorage.setItem('permisos_auth', permisos)
                    } else {
                      sessionStorage.setItem('permisos_auth', element.permisos.abilities)
                    }
                  } else {
                    if (response.data.data.nivel === 1 || response.data.data.nivel === 2) {
                      const permisos = []
                      const denegados = response.data.data.company.denegado
                      element.permisos.abilities.forEach(ability => {
                        if (!denegados.includes(ability)) {
                          permisos.push(ability)
                        }
                      })

                      sessionStorage.setItem('permisos_auth', permisos)
                    }
                  }
                } else {
                  if (response.data.data.nivel === -1 || response.data.data.nivel === 0) {
                    if (response.data.data.nivel === -1) {
                      const permisos = state.userProfile.role.permisos.abilities

                      // ONLY LEVEL SOPORT
                      permisos.push('exportation:list')

                      // permisos.push('nomenclators_countries:list')
                      sessionStorage.setItem('permisos_auth', permisos)
                    } else {
                      sessionStorage.setItem('permisos_auth', state.userProfile.role.permisos.abilities)
                    }
                  } else {
                    if (response.data.data.nivel === 1 || response.data.data.nivel === 2) {
                      const permisos = []
                      const denegados = response.data.data.company.denegado
                      element.permisos.abilities.forEach(ability => {
                        if (!denegados.includes(ability)) {
                          permisos.push(ability)
                        }
                      })

                      sessionStorage.setItem('permisos_auth', permisos)
                    }
                  }
                }
              }
            }
          }

          /* if (response.data.data.nivel === -1) {
            state.perfilesAuth.push({
              title: response.data.data.perfil_afiliado.name,
              icon: mdiHomeOutline,
              to: { name: 'dashboard', params: { perfil: response.data.data.perfil_afiliado.slug } },
              slug: response.data.data.perfil_afiliado.slug,
              permiso: '',
              active: sessionStorage.getItem('perfil') === response.data.data.perfil_afiliado.slug,
            })
          } else if (response.data.data.nivel === 0) {
            state.perfilesAuth.push({
              title: response.data.data.perfil_afiliado.name,
              icon: mdiHomeOutline,
              to: { name: 'dashboard', params: { perfil: response.data.data.perfil_afiliado.slug } },
              slug: response.data.data.perfil_afiliado.slug,
              permiso: '',
              active: sessionStorage.getItem('perfil') === response.data.data.perfil_afiliado.slug,
            })
          } else {
            if (response.data.data.nivel === 1) {
              // eslint-disable-next-line no-plusplus
              for (let index = 0; index < response.data.data.perfiles.length; index++) {
                const element = response.data.data.perfiles[index]
                if (element.active) {
                  state.perfilesAuth.push({
                    title: element.name,
                    icon: mdiHomeOutline,
                    to: { name: 'dashboard', params: { perfil: element.slug } },
                    slug: element.slug,
                    permiso: '',
                    active: sessionStorage.getItem('perfil') === element.slug,
                  })
                  if (sessionStorage.getItem('perfil') === element.slug) {
                    if (response.data.data.id_father === null) {
                      sessionStorage.setItem('permisos_auth', element.permisos.abilities)
                    } else {
                      sessionStorage.setItem('permisos_auth', state.userProfile.role.permisos.abilities)
                    }
                  }
                }
              }
            } else {
              state.perfilesAuth.push({
                title: response.data.data.agente.perfil.name,
                icon: mdiHomeOutline,
                to: { name: 'dashboard', params: { perfil: response.data.data.agente.perfil.slug } },
                slug: response.data.data.agente.perfil.slug,
                permiso: '',
                active: sessionStorage.getItem('perfil') === response.data.data.agente.perfil.slug,
              })
            }
          } */
        }
      })
      .catch(error => console.log(error))
  },

  verifyAllPermisosItem: (state, pos) => {
    const { frecuencias } = state

    frecuencias.push(frecuencias[pos])
  },

  // ACTUALIZAR EL ESTADO DEL PERFIL
  updatePerfilesAuth: (state, itemActive) => {
    state.perfilesAuth.forEach(element => {
      if (element.slug !== itemActive.slug) {
        // eslint-disable-next-line no-param-reassign
        element.active = false
      } else {
        // eslint-disable-next-line no-param-reassign
        element.active = true
      }
    })

    // console.log(state.perfilesAuth)
    // console.log(itemActive)
  },

  // ACTUALIZAR LOS PERMISOS DEL ROL O PERFIL AFILIADO
  editPermisosItem: (state, permisosItem) => {
    state.permisosItem = permisosItem
  },

  // EDITAR LA INFORMACION DE LA VISTA DE PERMISOS
  setPermisosTab: (state, view) => {
    state.sourcePermisos = []
    state.viewPermisos = view
  },
  setPermisosTabLoading: (state, status) => {
    state.isLoadingPagePermisos = status
  },
  verifyPermisoZona: (state, pos) => {
    // BOOKING
    if (
      state.sourcePermisos[pos].permisos.includes('cotizador:list')
      && state.sourcePermisos[pos].permisos.includes('reservas:list')
      && state.sourcePermisos[pos].permisos.includes('pvp:list')
      && state.sourcePermisos[pos].permisos.includes('tarifarios:list')
    ) {
      state.sourcePermisos[pos].all.checkboxBookingVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('cotizador:edit')
      && state.sourcePermisos[pos].permisos.includes('reservas:edit')
      && state.sourcePermisos[pos].permisos.includes('pvp:edit')
      && state.sourcePermisos[pos].permisos.includes('tarifarios:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxBookingEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('cotizador:create')
      && state.sourcePermisos[pos].permisos.includes('reservas:create')
      && state.sourcePermisos[pos].permisos.includes('pvp:create')
      && state.sourcePermisos[pos].permisos.includes('tarifarios:create')
    ) {
      state.sourcePermisos[pos].all.checkboxBookingCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('cotizador:destroy')
      && state.sourcePermisos[pos].permisos.includes('reservas:destroy')
      && state.sourcePermisos[pos].permisos.includes('pvp:destroy')
      && state.sourcePermisos[pos].permisos.includes('tarifarios:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxBookingDelete = true
    }

    // PRODUCTS
    if (
      state.sourcePermisos[pos].permisos.includes('flight:list')
      && state.sourcePermisos[pos].permisos.includes('hotel:list')
      && state.sourcePermisos[pos].permisos.includes('car:list')
    ) {
      state.sourcePermisos[pos].all.checkboxProductsVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('flight:edit')
      && state.sourcePermisos[pos].permisos.includes('hotel:edit')
      && state.sourcePermisos[pos].permisos.includes('car:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxProductsEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('flight:create')
      && state.sourcePermisos[pos].permisos.includes('hotel:create')
      && state.sourcePermisos[pos].permisos.includes('car:create')
    ) {
      state.sourcePermisos[pos].all.checkboxProductsCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('flight:destroy')
      && state.sourcePermisos[pos].permisos.includes('hotel:destroy')
      && state.sourcePermisos[pos].permisos.includes('car:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxProductsDelete = true
    }

    // CONTRATOS
    if (
      state.sourcePermisos[pos].permisos.includes('contrate_flights:list')
      && state.sourcePermisos[pos].permisos.includes('contrate_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('contrate_cars:list')
      && state.sourcePermisos[pos].permisos.includes('stopSale:list')
      && state.sourcePermisos[pos].permisos.includes('oferts:list')
    ) {
      state.sourcePermisos[pos].all.checkboxContrateVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('contrate_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('contrate_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('contrate_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('stopSale:edit')
      && state.sourcePermisos[pos].permisos.includes('oferts:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxContrateEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('contrate_flights:create')
      && state.sourcePermisos[pos].permisos.includes('contrate_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('contrate_cars:create')
      && state.sourcePermisos[pos].permisos.includes('stopSale:create')
      && state.sourcePermisos[pos].permisos.includes('oferts:create')
    ) {
      state.sourcePermisos[pos].all.checkboxContrateCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('contrate_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('contrate_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('contrate_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('stopSale:destroy')
      && state.sourcePermisos[pos].permisos.includes('oferts:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxContrateDelete = true
    }

    // ADMINISTRATION
    if (
      state.sourcePermisos[pos].permisos.includes('comisiones:list')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_cobrar:list')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_pagar:list')
      && state.sourcePermisos[pos].permisos.includes('pays_recibidos:list')
      && state.sourcePermisos[pos].permisos.includes('pays_emitidos:list')
      && state.sourcePermisos[pos].permisos.includes('markup:list')
      && state.sourcePermisos[pos].permisos.includes('finanzas:list')
    ) {
      state.sourcePermisos[pos].all.checkboxAdministrationVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('comisiones:edit')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_cobrar:edit')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_pagar:edit')
      && state.sourcePermisos[pos].permisos.includes('pays_recibidos:edit')
      && state.sourcePermisos[pos].permisos.includes('pays_emitidos:edit')
      && state.sourcePermisos[pos].permisos.includes('markup:edit')
      && state.sourcePermisos[pos].permisos.includes('finanzas:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxAdministrationEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('comisiones:create')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_cobrar:create')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_pagar:create')
      && state.sourcePermisos[pos].permisos.includes('pays_recibidos:create')
      && state.sourcePermisos[pos].permisos.includes('pays_emitidos:create')
      && state.sourcePermisos[pos].permisos.includes('markup:create')
      && state.sourcePermisos[pos].permisos.includes('finanzas:create')
    ) {
      state.sourcePermisos[pos].all.checkboxAdministrationCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('comisiones:destroy')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_cobrar:destroy')
      && state.sourcePermisos[pos].permisos.includes('ctas_x_pagar:destroy')
      && state.sourcePermisos[pos].permisos.includes('pays_recibidos:destroy')
      && state.sourcePermisos[pos].permisos.includes('pays_emitidos:destroy')
      && state.sourcePermisos[pos].permisos.includes('markup:destroy')
      && state.sourcePermisos[pos].permisos.includes('finanzas:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxAdministrationDelete = true
    }

    // CONFIGURATION
    if (
      state.sourcePermisos[pos].permisos.includes('config_general:list')
      && state.sourcePermisos[pos].permisos.includes('perfil_afiliado:list')
      && state.sourcePermisos[pos].permisos.includes('user_register:list')
      && state.sourcePermisos[pos].permisos.includes('role:list')
      && state.sourcePermisos[pos].permisos.includes('user:list')
      && state.sourcePermisos[pos].permisos.includes('users_son:list')
      && state.sourcePermisos[pos].permisos.includes('agente:list')
      && state.sourcePermisos[pos].permisos.includes('newletters:list')
    ) {
      state.sourcePermisos[pos].all.checkboxConfigurationVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('config_general:edit')
      && state.sourcePermisos[pos].permisos.includes('perfil_afiliado:edit')
      && state.sourcePermisos[pos].permisos.includes('user_register:edit')
      && state.sourcePermisos[pos].permisos.includes('role:edit')
      && state.sourcePermisos[pos].permisos.includes('user:edit')
      && state.sourcePermisos[pos].permisos.includes('users_son:edit')
      && state.sourcePermisos[pos].permisos.includes('agente:edit')
      && state.sourcePermisos[pos].permisos.includes('newletters:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxConfigurationEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('config_general:create')
      && state.sourcePermisos[pos].permisos.includes('perfil_afiliado:create')
      && state.sourcePermisos[pos].permisos.includes('user_register:create')
      && state.sourcePermisos[pos].permisos.includes('role:create')
      && state.sourcePermisos[pos].permisos.includes('user:create')
      && state.sourcePermisos[pos].permisos.includes('users_son:create')
      && state.sourcePermisos[pos].permisos.includes('agente:create')
      && state.sourcePermisos[pos].permisos.includes('newletters:create')
    ) {
      state.sourcePermisos[pos].all.checkboxConfigurationCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('config_general:destroy')
      && state.sourcePermisos[pos].permisos.includes('perfil_afiliado:destroy')
      && state.sourcePermisos[pos].permisos.includes('user_register:destroy')
      && state.sourcePermisos[pos].permisos.includes('role:destroy')
      && state.sourcePermisos[pos].permisos.includes('user:destroy')
      && state.sourcePermisos[pos].permisos.includes('users_son:destroy')
      && state.sourcePermisos[pos].permisos.includes('agente:destroy')
      && state.sourcePermisos[pos].permisos.includes('newletters:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxConfigurationDelete = true
    }

    // APIs
    if (
      state.sourcePermisos[pos].permisos.includes('api_keys:list')
      && state.sourcePermisos[pos].permisos.includes('api_tti:list')
      && state.sourcePermisos[pos].permisos.includes('api_amadeus:list')
      && state.sourcePermisos[pos].permisos.includes('api_redsys:list')
      && state.sourcePermisos[pos].permisos.includes('api_sibs:list')
      && state.sourcePermisos[pos].permisos.includes('api_authorize_net:list')
      && state.sourcePermisos[pos].permisos.includes('currencyapi:list')
    ) {
      state.sourcePermisos[pos].all.checkboxAPIsVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('api_keys:edit')
      && state.sourcePermisos[pos].permisos.includes('api_tti:edit')
      && state.sourcePermisos[pos].permisos.includes('api_amadeus:edit')
      && state.sourcePermisos[pos].permisos.includes('api_redsys:edit')
      && state.sourcePermisos[pos].permisos.includes('api_sibs:edit')
      && state.sourcePermisos[pos].permisos.includes('api_authorize_net:edit')
      && state.sourcePermisos[pos].permisos.includes('currencyapi:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxAPIsEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('api_keys:create')
      && state.sourcePermisos[pos].permisos.includes('api_tti:create')
      && state.sourcePermisos[pos].permisos.includes('api_amadeus:create')
      && state.sourcePermisos[pos].permisos.includes('api_redsys:create')
      && state.sourcePermisos[pos].permisos.includes('api_sibs:create')
      && state.sourcePermisos[pos].permisos.includes('api_authorize_net:create')
      && state.sourcePermisos[pos].permisos.includes('currencyapi:create')
    ) {
      state.sourcePermisos[pos].all.checkboxAPIsCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('api_keys:destroy')
      && state.sourcePermisos[pos].permisos.includes('api_tti:destroy')
      && state.sourcePermisos[pos].permisos.includes('api_amadeus:destroy')
      && state.sourcePermisos[pos].permisos.includes('api_redsys:destroy')
      && state.sourcePermisos[pos].permisos.includes('api_sibs:destroy')
      && state.sourcePermisos[pos].permisos.includes('api_authorize_net:destroy')
      && state.sourcePermisos[pos].permisos.includes('currencyapi:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxAPIsDelete = true
    }

    // NOMENCLADORES VUELOS
    if (
      state.sourcePermisos[pos].permisos.includes('nom_aerolines:list')
      && state.sourcePermisos[pos].permisos.includes('airplane:list')
      && state.sourcePermisos[pos].permisos.includes('nom_clase_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifa_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_dimensiones_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_peso_equipaje_flights:list')
      && state.sourcePermisos[pos].permisos.includes('airport:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tarjeta_fidelidad_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_code_ofac_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_politica_tarifaria_flights:list')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_fligths:list')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_fligths:list')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_aerolines:edit')
      && state.sourcePermisos[pos].permisos.includes('airplane:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_clase_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifa_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_dimensiones_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_peso_equipaje_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('airport:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tarjeta_fidelidad_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_code_ofac_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_politica_tarifaria_flights:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_fligths:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_fligths:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_aerolines:create')
      && state.sourcePermisos[pos].permisos.includes('airplane:create')
      && state.sourcePermisos[pos].permisos.includes('nom_clase_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifa_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_dimensiones_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_peso_equipaje_flights:create')
      && state.sourcePermisos[pos].permisos.includes('airport:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tarjeta_fidelidad_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_code_ofac_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_politica_tarifaria_flights:create')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_fligths:create')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_fligths:create')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_aerolines:destroy')
      && state.sourcePermisos[pos].permisos.includes('airplane:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_clase_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifa_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_dimensiones_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_peso_equipaje_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('airport:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tarjeta_fidelidad_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_code_ofac_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_politica_tarifaria_flights:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_fligths:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_fligths:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightDelete = true
    }

    // NOMENCLADORES AUTOS
    if (
      state.sourcePermisos[pos].permisos.includes('nom_transmision_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_type_auto_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_model_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_combustible_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_caracteristica_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_rentadora_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_x_km_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_edades_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tags_pto_recogida_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_oficina_renta_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_cars:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_cars:list')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresCarsVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_transmision_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_type_auto_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_model_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_combustible_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_caracteristica_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_rentadora_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_x_km_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_edades_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tags_pto_recogida_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_oficina_renta_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_cars:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_cars:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresCarsEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_transmision_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_type_auto_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_model_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_combustible_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_caracteristica_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_rentadora_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_x_km_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_edades_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tags_pto_recogida_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_oficina_renta_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_cars:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_cars:create')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresCarsCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_transmision_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_type_auto_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_model_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_combustible_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_caracteristica_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_rentadora_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tarifas_x_km_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_edades_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tags_pto_recogida_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_oficina_renta_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_cars:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_cars:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresCarsDelete = true
    }

    // NOMENCLADORES HOTELES
    if (
      state.sourcePermisos[pos].permisos.includes('nom_tipo_destino_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_operador_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_asociada_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_categorias_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_intereses_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_servicios_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_habitacion_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_regimen_alimenticio:list')
      && state.sourcePermisos[pos].permisos.includes('nom_edad_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_reducciones_contrate_hotels:list')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_hotels:list')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresHotelsVer = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_tipo_destino_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_operador_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_asociada_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_categorias_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_intereses_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_servicios_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_habitacion_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_regimen_alimenticio:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_edad_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_reducciones_contrate_hotels:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_hotels:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresHotelsEdit = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_tipo_destino_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_operador_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_asociada_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_categorias_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_intereses_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_servicios_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_habitacion_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_regimen_alimenticio:create')
      && state.sourcePermisos[pos].permisos.includes('nom_edad_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_reducciones_contrate_hotels:create')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_hotels:create')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresHotelsCreate = true
    }
    if (
      state.sourcePermisos[pos].permisos.includes('nom_tipo_destino_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_operador_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_marca_asociada_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_categorias_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_intereses_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_servicios_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_habitacion_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_regimen_alimenticio:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_edad_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_tag_imagen_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_suplemento_contrate_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_reducciones_contrate_hotels:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_conditions_generals_hotels:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresHotelsDelete = true
    }

    // NOMENCLADORES ALL
    if (
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightVer
      && state.sourcePermisos[pos].all.checkboxNomencladoresCarsVer
      && state.sourcePermisos[pos].all.checkboxNomencladoresHotelsVer
      && state.sourcePermisos[pos].permisos.includes('tipo_afiliado:list')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_conditions:list')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresVer = true
    }
    if (
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightEdit
      && state.sourcePermisos[pos].all.checkboxNomencladoresCarsEdit
      && state.sourcePermisos[pos].all.checkboxNomencladoresHotelsdit
      && state.sourcePermisos[pos].permisos.includes('tipo_afiliado:edit')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_conditions:edit')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresEdit = true
    }
    if (
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightCreate
      && state.sourcePermisos[pos].all.checkboxNomencladoresCarsCreate
      && state.sourcePermisos[pos].all.checkboxNomencladoresHotelsCreate
      && state.sourcePermisos[pos].permisos.includes('tipo_afiliado:create')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_conditions:create')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresCreate = true
    }
    if (
      state.sourcePermisos[pos].all.checkboxNomencladoresFlightDelete
      && state.sourcePermisos[pos].all.checkboxNomencladoresCarsDelete
      && state.sourcePermisos[pos].all.checkboxNomencladoresHotelsDelete
      && state.sourcePermisos[pos].permisos.includes('tipo_afiliado:destroy')
      && state.sourcePermisos[pos].permisos.includes('nom_categories_conditions:destroy')
    ) {
      state.sourcePermisos[pos].all.checkboxNomencladoresDelete = true
    }
  },

  // USERS
  setSearchUsers: (state, items) => {
    state.searchUsers = items
  },
  setUserUpdate: (state, item) => {
    state.userUpdate = item
  },
  setUserUpdateAvatar: (state, item) => {
    state.userUpdateAvatar = item
  },
  setUserOnlyShow: (state, status) => {
    state.userOnlyShow = status
  },
  setUserItemsPerPage: (state, cant) => {
    state.userItemsPerPage = cant
  },
  setTotalUsersFilters: (state, total) => {
    state.totalUsersFilters = total
  },
  setTotalUsersAll: (state, total) => {
    state.totalUsersAll = total
  },

  // HOTELS
  updateAddressHotel: (state, addressHotel) => {
    state.addressHotel.country = addressHotel.country
    state.addressHotel.state = addressHotel.state
    state.addressHotel.city = addressHotel.city
    if (addressHotel.direccion) {
      state.addressHotel.direccion = addressHotel.direccion
    }
  },
  resetAddressHotel: state => {
    state.addressHotel = {
      country: null,
      state: null,
      city: null,
      direccion: null,
    }
  },
  adicionarContactHotel: state => {
    const { contactsHotel } = state
    contactsHotel.push({
      name: '',
      rol: '',
      emails: [{ email: null }],
      telefonos: [{ number: null, exts: [{ ext: null }] }],
    })
  },
  deleteContactHotel: (state, pos) => {
    const { contactsHotel } = state

    contactsHotel.splice(pos, 1)
  },
  updateContactHotel: (state, contacts) => {
    state.contactsHotel = contacts
  },
  adicionarEmailContactHotel: (state, pos) => {
    const { contactsHotel } = state
    contactsHotel[pos].emails.push({ email: null })
  },
  deleteEmailContactHotel: (state, { pos, index }) => {
    const { contactsHotel } = state

    contactsHotel[pos].emails.splice(index, 1)
  },
  adicionarTelefonoContactHotel: (state, pos) => {
    const { contactsHotel } = state
    contactsHotel[pos].telefonos.push({ number: null, exts: [{ ext: null }] })
  },
  deleteTelefonoContactHotel: (state, { pos, index }) => {
    const { contactsHotel } = state

    contactsHotel[pos].telefonos.splice(index, 1)
  },
  adicionarExtTelefonoContactHotel: (state, { pos, posTelefono }) => {
    const { contactsHotel } = state
    contactsHotel[pos].telefonos[posTelefono].exts.push({ ext: null })
  },
  deleteExtTelefonoContactHotel: (state, { pos, posTelefono, index }) => {
    const { contactsHotel } = state

    contactsHotel[pos].telefonos[posTelefono].exts.splice(index, 1)
  },

  adicionarUrlVideo: state => {
    const { videos_url } = state
    videos_url.push({
      id: uuidv4(),
      url: 'https://',
    })
  },
  deleteUrlVideo: (state, pos) => {
    const { videos_url } = state

    videos_url.splice(pos, 1)
  },
  updateUrlVideo: (state, items) => {
    state.videos_url = items
  },

  // OFICINA RENTA
  updateOficinaRenta: (state, oficinaRenta) => {
    state.oficinaRenta.country = oficinaRenta.country
    state.oficinaRenta.country_code = oficinaRenta.country_code
    state.oficinaRenta.state = oficinaRenta.state
    state.oficinaRenta.city = oficinaRenta.city
  },
  editOficinaRenta: (state, oficce) => {
    state.oficinaRenta = oficce
  },

  // AIRPORT
  updateAirport: (state, aiport) => {
    state.airport.country = aiport.country
    state.airport.state = aiport.state
    state.airport.city = aiport.city
  },
  editAirport: (state, aiport) => {
    state.airport = aiport
  },
  setOnlyShow: (state, status) => {
    state.onlyShow = status
  },
  resetAirport: state => {
    state.airport = {
      iata: null,
      name: null,
      country: null,
      state: null,
      city: null,
      direccion: null,
    }
  },
  resetOficinaRenta: state => {
    state.oficinaRenta = {
      name: null,
      ptos_recogida: null,
      country: null,
      state: null,
      city: null,
      direccion: null,
    }
  },
  resetGeoTag: state => {
    state.geotag = {
      longitud: null,
      latitud: null,
    }
  },

  // COTIZADOR FLIGHTS
  addDestinoCotizadorFligth: state => {
    state.destinosCotizadorFlight.push({
      origen: null,
      destino: null,
      from: null,
      to: null,
    })
  },
  resetCotizadorFligth: state => {
    state.cotizadorFlight = {
      cant_adults: 1,
      cant_ninnos: 0,
      cant_infant: 0,
      aerolinea: 0,
      aerolinea_name: 'Todas',
      onlyIda: false,
      destinosMultiples: false,
    }
  },
  deleteDestinoCotizadorFligth: (state, pos) => {
    const { destinosCotizadorFlight } = state

    destinosCotizadorFlight.splice(pos, 1)
  },
  resetDestinoCotizadorFligth: state => {
    const { destinosCotizadorFlight } = state

    destinosCotizadorFlight.splice(1, destinosCotizadorFlight.length)
  },
  emptyDestinoCotizadorFligth: state => {
    state.destinosCotizadorFlight = [
      {
        origen: null,
        destino: null,
        from: null,
        to: null,
      },
    ]
  },
  incrementAdultosCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_adults++
  },
  decrementAdultosCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_adults--
  },
  incrementChildCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_ninnos++
  },
  decrementChildCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_ninnos--
  },
  incrementInfantCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_infant++
  },
  decrementInfantCotizadorFligth: state => {
    // eslint-disable-next-line no-plusplus
    state.cotizadorFlight.cant_infant--
  },

  // RESULT
  setSearchCotizadorIdaFlight: (state, value) => {
    state.searchCotizadorIdaFlight = value
  },
  setSearchCotizadorFlights: (state, value) => {
    state.searchCotizadorFlights = value
  },
  setResultsCotizadorIdaFligth: (state, items) => {
    state.resultCotizadorIdaFlight = items
  },
  setAerolineCotizadorIdaFligth: (state, items) => {
    state.aerolineCotizadorIdaFlight = items
  },
  setIndexTarifaEconCotizadorIdaFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorIdaFlight[indAero].indexTarifa = index
  },
  setIndTarifaEconCotizadorIdaFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorIdaFlight[indAero].indTarifa = index
  },
  setAerolineCotizadorRegresoFligth: (state, items) => {
    state.aerolineCotizadorRegresoFlight = items
  },
  setIndexTarifaIdaEconCotizadorIdaBackFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorRegresoFlight[indAero].indexTarifaIda = index
  },
  setIndTarifaIdaEconCotizadorIdaBackFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorRegresoFlight[indAero].indTarifaIda = index
  },
  setIndexTarifaBackEconCotizadorIdaBackFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorRegresoFlight[indAero].indexTarifaRegreso = index
  },
  setIndTarifaBackEconCotizadorIdaBackFligth: (state, { indAero, index }) => {
    state.aerolineCotizadorRegresoFlight[indAero].indTarifaRegreso = index
  },
  setAerolineCotizadorDestinosFligth: (state, items) => {
    state.aerolineCotizadorDestinosFlight = items
  },
  setIndexTarifaEconCotizadorIdaDestinosFligth: (state, { indAero, indDestino, index }) => {
    state.aerolineCotizadorDestinosFlight[indAero].destinos[indDestino].indexTarifa = index
  },
  setIndTarifaEconCotizadorIdaDestinosFligth: (state, { indAero, indDestino, index }) => {
    state.aerolineCotizadorDestinosFlight[indAero].destinos[indDestino].indTarifa = index
  },

  setSearchingFlightCotizador: (state, valor) => {
    state.searchingFlightCotizador = valor
  },
  setPageSearchingFlightCotizador: (state, valor) => {
    state.pageSearchingFlightCotizador = valor
  },

  setCotizadorFlight: (state, item) => {
    state.cotizadorFlight = item
  },

  // SELECT
  setCotizadorFlightSelect: (state, item) => {
    state.cotizadorFlightSelect = item
  },
  setCotizadorPaxFlightSelect: (state, items) => {
    state.cotizadorPaxFlightSelect = items
  },
  setCotizadorFlightSelectMarkups: (state, item) => {
    state.cotizadorFlightSelectMarkups = item
  },
  setContactEmergencyAllCotizadorFlight: (state, { name, phone, email }) => {
    state.cotizadorPaxFlightSelect.forEach(element => {
      // eslint-disable-next-line no-param-reassign
      element.contact_emergency_name = name
      // eslint-disable-next-line no-param-reassign
      element.contact_emergency_phone = phone
      // eslint-disable-next-line no-param-reassign
      element.contact_emergency_email = email
    })
  },
  setCotizadorFlightSelectPrice: (state, { price_total, with_markup, with_descuento }) => {
    state.cotizadorFlightSelect.item_ida.tarifas_contrate.forEach(tarifa => {
      tarifa.price_total = price_total
      tarifa.with_markup = with_markup
      tarifa.with_descuento = with_descuento
    })
  },
  setCotizadorFlightSelectIdaBackPrice: (state, { with_markup, with_descuento }) => {
    state.cotizadorFlightSelect.item_ida.tarifas_contrate.forEach(tarifa => {
      tarifa.price_total = tarifa.price_inicial + with_markup - with_descuento
      tarifa.with_markup = with_markup
      tarifa.with_descuento = with_descuento
    })
    state.cotizadorFlightSelect.item_regreso.tarifas_contrate.forEach(tarifa => {
      tarifa.price_total = tarifa.price_inicial + with_markup - with_descuento
      tarifa.with_markup = with_markup
      tarifa.with_descuento = with_descuento
    })
  },
  setCotizadorFlightSelectDestinosPrice: (state, { with_markup, with_descuento }) => {
    state.cotizadorFlightSelect.destinos.forEach(destino => {
      destino.flights[destino.indexTarifa].tarifas_contrate.forEach(tarifa => {
        tarifa.price_total = tarifa.price_inicial + with_markup - with_descuento
        tarifa.with_markup = with_markup
        tarifa.with_descuento = with_descuento
      })
    })
  },

  // FAVORITES
  insertCotizadorFlightFavorite: (state, item) => {
    state.cotizadorFlightFavorite.push(item)
  },
  deleteCotizadorFlightFavorite: (state, item) => {
    state.cotizadorFlightFavorite.splice(state.cotizadorFlightFavorite.indexOf(item), 1)
  },
  clearCotizadorFlightFavorite: state => {
    state.cotizadorFlightFavorite = []
  },
  insertIdFlightFavorite: (state, id) => {
    state.idFlightFavorite.push(id)
  },
  deleteIdFlightFavorite: (state, id) => {
    state.idFlightFavorite.splice(state.idFlightFavorite.indexOf(id), 1)
  },
  clearIdFlightFavorite: state => {
    state.idFlightFavorite = []
  },

  // SCHEDULE
  setScheduleResult: (state, items) => {
    state.scheduleResult = items
  },
  setSchedulePageResult: (state, page) => {
    state.pageResult = page
  },
  setScheduleItemsPerPageResult: (state, cant) => {
    state.itemsPerPageResult = cant
  },

  // FILTROS COTIZADOR FLIGHT
  setFiltrosCotizadorFlight: (state, item) => {
    if (item.aerolinea !== undefined && item.aerolinea !== null) {
      state.filtrosCotizadorFlight.aerolinea = item.aerolinea
    }
    if (item.escala !== undefined && item.escala !== null) {
      state.filtrosCotizadorFlight.escala = item.escala
    }
    if (item.duracionEscala !== undefined && item.duracionEscala !== null) {
      state.filtrosCotizadorFlight.duracionEscala = item.duracionEscala
    }
    if (item.duracionViaje !== undefined && item.duracionViaje !== null) {
      state.filtrosCotizadorFlight.duracionViaje = item.duracionViaje
    }
    if (item.frecuencias !== undefined && item.frecuencias !== null) {
      state.filtrosCotizadorFlight.frecuencias = item.frecuencias
    }
    if (item.airport !== undefined && item.airport !== null) {
      state.filtrosCotizadorFlight.airport = item.airport
    }
    if (item.clase !== undefined && item.clase !== null) {
      state.filtrosCotizadorFlight.clase = item.clase
    }
    if (item.equipaje !== undefined && item.equipaje !== null) {
      state.filtrosCotizadorFlight.equipaje = item.equipaje
    }
    if (item.byMejorOpcion !== undefined && item.byMejorOpcion !== null) {
      state.filtrosCotizadorFlight.byMejorOpcion = item.byMejorOpcion
    }
    if (item.byMasEconomico !== undefined && item.byMasEconomico !== null) {
      state.filtrosCotizadorFlight.byMasEconomico = item.byMasEconomico
    }
    if (item.byMasRapido !== undefined && item.byMasRapido !== null) {
      state.filtrosCotizadorFlight.byMasRapido = item.byMasRapido
    }
  },

  // ESCALAS
  adicionarEscala: state => {
    state.escalas.push({
      city: '',
      id: 0,
      from: null,
      to: null,
      duration_h: 0,
      duration_m: 0,
    })
  },
  updateEscala: (state, escalas) => {
    state.escalas = escalas
  },
  deleteEscala: (state, escala) => {
    state.loadEscalas = true
    const { escalas } = state

    state.escalas = escalas.filter(geeks => geeks.city.id !== escala.city.id)
    setTimeout(() => {
      state.loadEscalas = false
    }, 100)
  },

  // FRECUENCIAS
  initFrecuencia: state => {
    state.frecuencias.push({
      frecuencia: [],
      fromValidez: null,
      toValidez: null,
      origen: {
        destino: null,
        salida: null,
        terminal: null,
        puerta: null,
        duration: null,
        durationM: null,
      },
      destino: {
        destino: null,
        llegada: null,
        terminal: null,
        puerta: null,
        days: null,
        duration: null,
        durationM: null,
      },
      days: 0,
      duration: '',
      durationM: 0,
      escalas: [],
      tiene_escalas: false,
    })
  },
  adicionarFrecuencia: state => {
    if (state.frecuencias.length > 0) {
      const frec = state.frecuencias[0]
      const origen = {
        destino: frec.origen.destino,
        salida: null,
        terminal: null,
        puerta: null,
        duration: null,
        durationM: null,
      }
      const destino = {
        destino: frec.destino.destino,
        llegada: null,
        terminal: null,
        puerta: null,
        days: null,
        duration: null,
        durationM: null,
      }
      const escalas = []
      frec.escalas.forEach(element => {
        escalas.push({
          city: element.city,
          llegada: null,
          llegadaDay: 0,
          llegadaTerminal: null,
          llegadaDuration: null,
          salida: null,
          salidaDay: 0,
          salidaTerminal: null,
          salidaDuration: null,
        })
      })
      state.frecuencias.push({
        frecuencia: [],
        fromValidez: frec.fromValidez,
        toValidez: frec.toValidez,
        origen,
        destino,
        days: '',
        duration: '',
        durationM: 0,
        escalas,
        tiene_escalas: frec.tiene_escalas,
      })
    } else {
      state.frecuencias.push({
        frecuencia: [],
        fromValidez: '',
        toValidez: '',
        origen: {
          destino: null,
          salida: null,
          terminal: null,
          puerta: null,
          duration: null,
          durationM: null,
        },
        destino: {
          destino: null,
          llegada: null,
          terminal: null,
          puerta: null,
          days: null,
          duration: null,
          durationM: null,
        },
        days: 0,
        duration: '',
        escalas: [],
        tiene_escalas: false,
      })
    }
  },
  addEscalaFrecuencia: (state, pos) => {
    const { frecuencias } = state
    frecuencias[pos].escalas.push({
      city: null,
      llegada: null,
      llegadaDay: null,
      llegadaTerminal: null,
      llegadaDuration: 0,
      llegadaDurationM: 0,
      salida: null,
      salidaDay: null,
      salidaTerminal: null,
      salidaDuration: 0,
      salidaDurationM: 0,
    })
  },
  deleteEscalaFrecuencia: (state, { pos, posFrecuencia }) => {
    const { frecuencias } = state
    frecuencias[posFrecuencia].escalas.splice(pos, 1)
  },
  deleteAllEscalaFrecuencia: (state, pos) => {
    const { frecuencias } = state
    frecuencias[pos].escalas = []
  },
  calculateLlegadaEscala: (state, pos) => {
    const { frecuencias } = state
    let beginningTime
    let idOrigen

    // POR SI NO TIENE ESCALAS
    if (frecuencias[pos].escalas.length === 0) {
      beginningTime = moment(frecuencias[pos].origen.salida, 'HH:mm')
      idOrigen = frecuencias[pos].origen.destino.id
    } else {
      beginningTime = moment(frecuencias[pos].escalas[frecuencias[pos].escalas.length - 1].salida, 'HH:mm')
      idOrigen = frecuencias[pos].escalas[frecuencias[pos].escalas.length - 1].city.id
    }

    const endTime = moment(frecuencias[pos].destino.llegada, 'HH:mm')
    const horaOrigen = beginningTime.format('HH:mm')
    const horaDestino = endTime.format('HH:mm')

    if (frecuencias[pos].destino.llegada) {
      /* if (beginningTime.isBefore(endTime)) {
        frecuencias[pos].destino.days = 0
      } else {
        frecuencias[pos].destino.days = 1
      } */

      const idDestino = frecuencias[pos].destino.destino.id

      const json = {
        idOrigen,
        horaOrigen,
        idDestino,
        horaDestino,
      }
      axios
        .post(`${process.env.VUE_APP_API_URL}calculate/flights-utc`, json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          // console.log(response.data)

          frecuencias[pos].destino.duration = response.data.duration
          frecuencias[pos].destino.durationM = response.data.durationM
          frecuencias[pos].destino.days = response.data.daysLlegada
        })
        .finally(() => {
          let days = 0
          let minutos = 0
          frecuencias[pos].escalas.forEach(element => {
            days = days + element.llegadaDay + element.salidaDay
            minutos = minutos + element.llegadaDurationM + element.salidaDurationM
          })
          frecuencias[pos].days = days + frecuencias[pos].destino.days
          const resulMin = minutos + frecuencias[pos].destino.durationM
          let textHours

          let hours = Math.floor(resulMin / 60)
          const mins = resulMin % 60
          if (hours !== 0 && mins !== 0) {
            if (mins >= 59) {
              hours += 1
              textHours = `${hours}:00`
            } else {
              textHours = `${hours}:${mins.toFixed(0)}`
            }
          } else if (hours === 0 && mins !== 0) {
            textHours = `00:${mins.toFixed(0)}`
          } else if (hours !== 0 && mins === 0) {
            textHours = `${hours}:00`
          }
          // eslint-disable-next-line prefer-destructuring
          frecuencias[pos].duration = textHours
          frecuencias[pos].durationM = resulMin
        })
    }
  },
  changeDaysCalculate: (state, pos) => {
    const { frecuencias } = state
    let days = 0

    frecuencias[pos].escalas.forEach(element => {
      days = days + parseInt(element.llegadaDay, 10) + parseInt(element.salidaDay, 10)
    })
    frecuencias[pos].days = days + parseInt(frecuencias[pos].destino.days, 10)
  },
  updateFrecuencia: (state, frecuencias) => {
    state.frecuencias = frecuencias
  },
  cloneFrecuencia: (state, frecuencia) => {
    const { frecuencias } = state
    frecuencias.push(frecuencia)
  },
  deleteFrecuencia: (state, pos) => {
    // state.loadFrecuencia = true
    const { frecuencias } = state

    frecuencias.splice(pos, 1)

    /* setTimeout(() => {
      state.loadFrecuencia = false
    }, 100) */
  },

  // CLASES DE VUELOS
  initClaseVuelo: state => {
    const { clasesVuelos } = state

    clasesVuelos.push({
      class_id: 0,
      tarifa_id: 0,
      cupo: 0,
      price_adult: 0,
      price_child: 0,
      price_infant: 0,

      equipaje_personal: {
        dimensiones: 0,
        peso: 0,
        precio: 0,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },

      equipaje_cabina: {
        dimensiones: 0,
        peso: 0,
        precio: 0,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },

      equipaje_bodega: {
        dimensiones: 0,
        lineal_dimensiones: 0,
        peso: 0,
        um_peso: '',
        number_peso: 0,
        maletas: [{ price: 0, incluida: false, permitida: false }],
        max_exceso_equipaje: 0,
        exceso_equipaje: 0,
        tasa_despacho: 0,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },
    })
    state.clasesVuelos = clasesVuelos
  },
  adicionarClaseVuelo: state => {
    const { clasesVuelos } = state

    clasesVuelos.push({
      class_id: 0,
      tarifa_id: 0,
      cupo: 0,
      price_adult: 0,
      price_child: 0,
      price_infant: 0,

      equipaje_personal: {
        dimensiones: 0,
        peso: 0,
        precio: 0,
        incluido: false,
        permitido: false,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },

      equipaje_cabina: {
        dimensiones: 0,
        peso: 0,
        precio: 0,
        incluido: false,
        permitido: false,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },

      equipaje_bodega: {
        dimensiones: 0,
        um_dimension: '',
        lineal_dimensiones: 0,
        peso: 0,
        um_peso: '',
        number_peso: 0,
        maletas: [{ price: 0, incluida: false, permitida: false }],
        max_exceso_equipaje: 0,
        exceso_equipaje: [],
        sobre_peso: false,
        max_exceso_dimension: 0,
        exceso_dimension: [],
        sobre_dimension: false,

        // exceso_equipaje: [{ peso_min: 0, peso_max: 0, price: 0 }],
        tasa_despacho: 0,
        incluido: false,
        permitido: false,
        aplica_adult: false,
        aplica_child: false,
        aplica_inf: false,
      },
    })
    state.clasesVuelos = clasesVuelos
  },
  adicionarMaletaCabina: state => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.maletas.push({ price: 0, incluida: false, permitida: false })
    })
  },
  deleteMaletaBodegaVuelo: (state, pos) => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.maletas.splice(pos, 1)
    })
  },
  adicionarExcesoEquipajeBodega: state => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.exceso_equipaje.push({ peso_min: 0, peso_max: 0, price: 0 })
    })
  },
  deleteExcesoEquipajeBodega: (state, pos) => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.exceso_equipaje.splice(pos, 1)
    })
  },
  adicionarDimensionEquipajeBodega: state => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.exceso_dimension.push({ dimension_min: 0, dimension_max: 0, price: 0 })
    })
  },
  deleteDimensionEquipajeBodega: (state, pos) => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      element.equipaje_bodega.exceso_dimension.splice(pos, 1)
    })
  },
  adicionarPrecioAdicionalVuelo: (state, clase) => {
    const { clasesVuelos } = state

    clasesVuelos.forEach(element => {
      if (element.class_id === clase.class_id) {
        element.precio_adicional.froms.push({
          from: 0,
          to: 0,
          price: 0,
          aplica_adult: false,
          aplica_child: false,
          aplica_inf: false,
        })
      }
    })
  },
  eliminarPrecioAdicionalVuelo: (state, { clase, from }) => {
    const { clasesVuelos } = state

    const classEdit = clasesVuelos.filter(geeks => geeks.class_id === clase.class_id)

    if (classEdit.length > 0) {
      const { froms } = classEdit[0].precio_adicional

      const fromsR = froms.filter(geeks => geeks.from !== from.from)
      // eslint-disable-next-line no-param-reassign
      clase.precio_adicional.froms = fromsR
    }
  },

  updateClaseVuelo: (state, clases) => {
    state.clasesVuelos = clases
  },
  deleteClaseVuelo: (state, pos) => {
    state.loadClasesVuelos = true
    const { clasesVuelos } = state

    clasesVuelos.splice(pos, 1)

    // state.clasesVuelos = clasesVuelos.filter(geeks => geeks.class_id !== clase.class_id)
    setTimeout(() => {
      state.loadClasesVuelos = false
    }, 100)
  },

  // Temporadas Markus
  adicionarTemporadaFlightMarkus: state => {
    state.temporadasFlightMarkups.push({
      fromValidez: '',
      toValidez: '',
    })
  },
  updateTemporadaFlightMarkus: (state, temporadasFlightMarkups) => {
    state.temporadasFlightMarkups = temporadasFlightMarkups
  },
  initMarkupsFlight: (state, typesAfiliados) => {
    state.markupsFlightMarkups.push({
      id_tipo_afiliado: 0,
      name_tipo_afiliado: 'Ventas Directas',
      valorAdult: '',
      pcAdult: '',
      valorChild: '',
      pcChild: '',
      valorInf: '',
      pcInf: '',
    })

    typesAfiliados.forEach(element => {
      state.markupsFlightMarkups.push({
        id_tipo_afiliado: element.id,
        name_tipo_afiliado: element.name,
        valorAdult: '',
        pcAdult: '',
        valorChild: '',
        pcChild: '',
        valorInf: '',
        pcInf: '',
      })
    })
  },
  updateMarkusFlight: (state, markupsFlightMarkups) => {
    state.markupsFlightMarkups = markupsFlightMarkups
  },
  deleteTemporadaFlightMarkus: (state, pos) => {
    const { temporadasFlightMarkups } = state

    temporadasFlightMarkups.splice(pos, 1)
  },

  // CARS
  updateGeoTag: (state, geotag) => {
    state.geotag = geotag
  },
  setPaisCode: (state, { name, countrySlug, code }) => {
    const { paiseCode } = state
    paiseCode.name = name
    paiseCode.countrySlug = countrySlug
    paiseCode.code = code
  },
  adicionarTelefono: state => {
    const { telefonos } = state
    if (telefonos.length > 0) {
      telefonos.push({ code: '', number: null, ext: null })
    } else {
      console.log(telefonos[0])
      telefonos.push({ code: state.telefonos[0].code, number: null, ext: null })
    }
  },
  deleteTelefono: (state, pos) => {
    const { telefonos } = state

    telefonos.splice(pos, 1)
  },
  updateTelefonos: (state, telefonos) => {
    state.telefonos = telefonos
  },
  adicionarHorario: state => {
    state.horarios.push({
      modelSemana: [0, 1, 2, 3, 4, 5, 6],
      is_time_completo: true,
      horarios: [],
    })
  },
  deleteHorario: (state, pos) => {
    const { horarios } = state

    horarios.splice(pos, 1)
  },
  adicionarHorarioComponent: (state, { posOficce, posH }) => {
    state.oficceRent[posOficce].horarios[posH].horarios.push({ from: '', to: '' })
  },
  deleteHorarioComponent: (state, { posOficce, posH, pos }) => {
    state.oficceRent[posOficce].horarios[posH].horarios.splice(pos, 1)
  },
  updateHorarios: (state, horarios) => {
    state.horarios = horarios
  },
  setTimeCompletoOficinal: (state, { posOficce, pos, isTimeCompleto }) => {
    state.oficceRent[posOficce].horarios[pos].is_time_completo = isTimeCompleto
    if (!isTimeCompleto) {
      state.oficceRent[posOficce].horarios[pos].horarios = [{ from: '', to: '' }]
    } else {
      state.oficceRent[posOficce].horarios[pos].horarios = []
    }
  },
  addHorarioOficceRent: (state, posOficce) => {
    state.oficceRent[posOficce].horarios.push({
      modelSemana: [0, 1, 2, 3, 4, 5, 6],
      is_time_completo: true,
      horarios: [],
    })
  },
  deleteHorarioOficceRent: (state, { pos, posOficce }) => {
    state.oficceRent[posOficce].horarios.splice(pos, 1)
  },
  adicionarOficceRent: (state, { oficina_id, telefonos, horarios }) => {
    state.oficceRent.push({
      oficina_id,
      telefonos,
      horarios,
    })
  },
  updateOficceRent: (state, items) => {
    state.oficceRent = items
  },
  deleteOficceRent: (state, pos) => {
    const { oficceRent } = state

    oficceRent.splice(pos, 1)
  },
  addTelefonoOficceRent: (state, pos) => {
    if (state.oficceRent[pos].telefonos.length === 0) {
      state.oficceRent[pos].telefonos.push({
        code: '',
        number: null,
        ext: null,
      })
    } else {
      state.oficceRent[pos].telefonos.push({
        code: state.oficceRent[pos].telefonos[0].code,
        number: null,
        ext: null,
      })
    }
  },
  deleteTelefonoOficceRent: (state, { pos, posOficce }) => {
    const { oficceRent } = state

    oficceRent[posOficce].telefonos.splice(pos, 1)
  },
  adicionarImgCars: (state, { galery, resource }) => {
    galery.forEach(element => {
      state.galeria.push({
        tag: null,
        principal: false,
        resource,
        image: element,
      })
    })
  },
  deleteImgCars: (state, pos) => {
    const { galeria } = state

    galeria.splice(pos, 1)
  },
  adicionarImgHotels: (state, { galery, resource }) => {
    galery.forEach(element => {
      state.galeriaHotels.push({
        tag: null,
        principal: false,
        resource,
        image: element,
      })
    })
  },
  deleteImgHotels: (state, pos) => {
    const { galeriaHotels } = state

    galeriaHotels.splice(pos, 1)
  },
  updateImgCars: (state, galery) => {
    state.galeria = galery
  },
  updateImgHotels: (state, galery) => {
    state.galeriaHotels = galery
  },
  setImgLoading: (state, status) => {
    state.loadImg = status
  },

  // VIDEOS
  adicionarVideoCars: (state, { videos, resource }) => {
    videos.forEach(element => {
      state.videos.push({
        procesado: false,
        resource,
        url: element,
      })
    })
  },
  deleteVideoCars: (state, pos) => {
    const { videos } = state

    videos.splice(pos, 1)
  },
  updateVideosCars: (state, videos) => {
    state.videos = videos
  },

  // CARS CONTRATE
  addCategoryContrateCar: (state, { edad_id, edad_max_id }) => {
    const { categoryContrateCar } = state

    categoryContrateCar.push({
      category_id: null,
      edad_id,
      edad_max_id,
      cars_id: [],
    })

    this.verifyPricesTemporadasContrateCar()
  },
  deleteCategoryContrateCar: (state, pos) => {
    const { categoryContrateCar } = state

    // VALIDAR Q SE ELIMINE LOS PRECIOS PARA ESA TEMPORADA
    const { pricesTemporadasContrateCar } = state
    const newPrices = []
    pricesTemporadasContrateCar.forEach(price => {
      // eslint-disable-next-line no-empty
      if (price.category_id === categoryContrateCar[pos].category_id) {
      } else {
        newPrices.push(price)
      }
    })
    state.pricesTemporadasContrateCar = newPrices

    categoryContrateCar.splice(pos, 1)

    this.verifyPricesTemporadasContrateCar()
  },
  updateCategoryContrateCar: (state, update) => {
    state.categoryContrateCar = update
  },
  addMarcaModeloContrateCar: (state, { edad_id, edad_max_id }) => {
    const { marcasModeloContrateCar } = state

    marcasModeloContrateCar.push({
      marca_id: uuidv4(),
      edad_id,
      edad_max_id,
      cars_id: [],
    })

    this.verifyPricesTemporadasContrateCar()
  },
  deleteMarcaModeloContrateCar: (state, pos) => {
    const { marcasModeloContrateCar } = state

    // VALIDAR Q SE ELIMINE LOS PRECIOS PARA ESA TEMPORADA
    const { pricesTemporadasContrateCar } = state
    const newPrices = []
    pricesTemporadasContrateCar.forEach(price => {
      // eslint-disable-next-line no-empty
      if (price.marca_id === marcasModeloContrateCar[pos].marca_id) {
      } else {
        newPrices.push(price)
      }
    })
    state.pricesTemporadasContrateCar = newPrices

    marcasModeloContrateCar.splice(pos, 1)

    this.verifyPricesTemporadasContrateCar()
  },
  updateMarcaModeloContrateCar: (state, update) => {
    state.marcasModeloContrateCar = update
  },
  addTemporadaContrateCar: state => {
    const { temporadasContrateCar } = state

    temporadasContrateCar.push({
      temporada_id: uuidv4(),
      name: null,
      dates: [{ from: null, to: null }],
      tarifas_id: [],
      release: 3,
    })
  },
  deleteTemporadaContrateCar: (state, pos) => {
    const { temporadasContrateCar } = state

    // VALIDAR Q SE ELIMINE LOS PRECIOS PARA ESA TEMPORADA
    const { pricesTemporadasContrateCar } = state
    const newPrices = []
    pricesTemporadasContrateCar.forEach(price => {
      // eslint-disable-next-line no-empty
      if (price.temporada_id === temporadasContrateCar[pos].temporada_id) {
      } else {
        newPrices.push(price)
      }
    })
    state.pricesTemporadasContrateCar = newPrices

    temporadasContrateCar.splice(pos, 1)

    this.verifyPricesTemporadasContrateCar()
  },
  updateTemporadaContrateCar: (state, update) => {
    state.temporadasContrateCar = update
  },
  addDateTemporadaContrateCar: (state, posSeason) => {
    state.temporadasContrateCar[posSeason].dates.push({ from: null, to: null })
  },
  deleteDateTemporadaContrateCar: (state, { posSeason, posDate }) => {
    state.temporadasContrateCar[posSeason].dates.splice(posDate, 1)
  },
  addSuplementoContrateCar: (
    state,
    {
      from,
      to,
      suplemento_id,
      price,
      obligatorio,
      tarifas_id,
      tarifas_retorno,
      tarifas_combustible,
      seguros_edad_conductor,
    },
  ) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar.push({
      suplemento_id,
      from,
      to,
      price,
      obligatorio,
      tarifas_id,
      tarifas_retorno,
      tarifas_combustible,
      seguros_edad_conductor,
    })
  },
  setSuplementoContrateCar: (state, item) => {
    state.suplementoCar = item
  },
  deleteSuplementoContrateCar: (state, pos) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar.splice(pos, 1)
  },
  updateSuplementoContrateCarOne: (
    state,
    {
      pos,
      from,
      to,
      suplemento_id,
      price,
      obligatorio,
      tarifas_id,
      tarifas_retorno,
      tarifas_combustible,
      seguros_edad_conductor,
    },
  ) => {
    state.suplementosContrateCar[pos] = {
      suplemento_id,
      from,
      to,
      price,
      obligatorio,
      tarifas_id,
      tarifas_retorno,
      tarifas_combustible,
      seguros_edad_conductor,
    }
  },
  updateSuplementoContrateCar: (state, update) => {
    state.suplementosContrateCar = update
  },
  setContrateCarFreeSale: (state, update) => {
    state.contrateCarFreeSale = update
  },
  addSeguroEdadConductorSuplementoContrateCar: (
    state,
    {
      indSuplementoCar, category_id, marca_id, edad_min, edad_max,
    },
  ) => {
    state.suplementosContrateCar[indSuplementoCar].seguros_edad_conductor.push({
      category_id,
      marca_id,
      price: null,
      edad_min,
      edad_max,
    })
  },
  deleteSeguroEdadConductorSuplementoContrateCar: (state, { pos, indSuplementoCar }) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar[indSuplementoCar].seguros_edad_conductor.splice(pos, 1)
  },
  addTarifaCombustibleSuplementoContrateCar: (state, {
    indSuplementoCar, category_id, marca_id, price,
  }) => {
    state.suplementosContrateCar[indSuplementoCar].tarifas_combustible.push({
      category_id,
      marca_id,
      price,
    })
  },
  deleteTarifaCombustibleSuplementoContrateCar: (state, { pos, indSuplementoCar }) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar[indSuplementoCar].tarifas_combustible.splice(pos, 1)
  },
  addTarifaXKmSuplementoContrateCar: (state, { indSuplementoCar, tarifa_id, tarifa_prices }) => {
    state.suplementosContrateCar[indSuplementoCar].tarifas_retorno.push({
      tarifa_id,
      tarifa_prices,
    })
  },
  deleteTarifaXKmSuplementoContrateCar: (state, { pos, indSuplementoCar }) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar[indSuplementoCar].tarifas_retorno.splice(pos, 1)
  },
  addPriceTarifaXKmSuplementoContrateCar: (state, {
    indSuplementoCar, indTarifaRetorno, tarifa_id, price,
  }) => {
    state.suplementosContrateCar[indSuplementoCar].tarifas_retorno[indTarifaRetorno].tarifa_prices.push({
      tarifa_id,
      price,
    })
  },
  deletePriceTarifaXKmSuplementoContrateCar: (state, { pos, indSuplementoCar, indTarifaRetorno }) => {
    const { suplementosContrateCar } = state

    suplementosContrateCar[indSuplementoCar].tarifas_retorno[indTarifaRetorno].tarifa_prices.splice(pos, 1)
  },

  addSuplementoContrateFlight: (state, {
    from, to, suplemento_id, price, obligatorio, online,
  }) => {
    const { suplementosContrateFlight } = state

    suplementosContrateFlight.push({
      suplemento_id,
      from,
      to,
      price,
      obligatorio,
      online,
    })
  },
  updateSuplementoContrateFlight: (state, update) => {
    state.suplementosContrateFlight = update
  },
  setSuplementoContrateFlight: (state, item) => {
    state.suplementoFlight = item
  },
  deleteSuplementoContrateFlight: (state, pos) => {
    const { suplementosContrateFlight } = state

    suplementosContrateFlight.splice(pos, 1)
  },
  updateSuplementoContrateFlightOne: (state, {
    pos, from, to, suplemento_id, price, obligatorio, online,
  }) => {
    state.suplementosContrateFlight[pos] = {
      suplemento_id,
      from,
      to,
      price,
      obligatorio,
      online,
    }
  },

  verifyPricesTemporadasContrateCar: state => {
    const { temporadasContrateCar } = state
    const { categoryContrateCar } = state
    const { pricesTemporadasContrateCar } = state
    const { marcasModeloContrateCar } = state

    if (temporadasContrateCar.length > 0) {
      temporadasContrateCar.forEach(season => {
        categoryContrateCar.forEach(category => {
          const prices = pricesTemporadasContrateCar.filter(
            e => e.temporada_id === season.temporada_id && e.category_id === category.category_id.id,
          )

          // CREAR LA TARIFA
          if (prices.length === 0) {
            const arrTarif = []
            arrTarif.push({ tarifa_id: 'seguro', price: 0 })
            arrTarif.push({ tarifa_id: 'deposito', price: 0 })
            arrTarif.push({ tarifa_id: 'day_extra', price: 0 })
            season.tarifas_id.forEach(element => {
              arrTarif.push({ tarifa_id: element, price: 0 })
            })
            pricesTemporadasContrateCar.push({
              category_id: category.category_id.id,
              marca_id: null,
              temporada_id: season.temporada_id,
              from: season.from,
              to: season.to,
              prices: arrTarif,
              cupos: [{ oficina_id: [-1], cuposDisponible: null, cuposTotal: null }],
            })
          } else {
            // BUSCAR SI LA TARIFA EXISTIA
            let find = false
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < pricesTemporadasContrateCar.length; index++) {
              const element = pricesTemporadasContrateCar[index]
              if (element.temporada_id === season.temporada_id && element.category_id === category.category_id.id) {
                // VERIFICAR SI YA EXITIA LA TARIFA
                const tarifaPrice = pricesTemporadasContrateCar[index].prices

                const arrTarif = []
                arrTarif.push({
                  tarifa_id: 'seguro',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'seguro')[0].price,
                })
                arrTarif.push({
                  tarifa_id: 'deposito',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'deposito')[0].price,
                })
                arrTarif.push({
                  tarifa_id: 'day_extra',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'day_extra')[0].price,
                })
                season.tarifas_id.forEach(elementTarif => {
                  const oldPrice = tarifaPrice.filter(e => e.tarifa_id === elementTarif)
                  if (oldPrice.length > 0) {
                    arrTarif.push({ tarifa_id: elementTarif, price: oldPrice[0].price })
                  } else {
                    arrTarif.push({ tarifa_id: elementTarif, price: 0 })
                  }
                })
                const newValue = {
                  category_id: category.category_id.id,
                  marca_id: null,
                  temporada_id: season.temporada_id,
                  from: season.from,
                  to: season.to,
                  prices: arrTarif,
                  cupos: pricesTemporadasContrateCar[index].cupos,
                }

                pricesTemporadasContrateCar[index] = newValue
                find = true
              }
            }

            // CREAR LA TARIFA PORQ NO EXISTIA
            if (!find) {
              const arrTarifN = []
              arrTarifN.push({ tarifa_id: 'seguro', price: 0 })
              arrTarifN.push({ tarifa_id: 'deposito', price: 0 })
              arrTarifN.push({ tarifa_id: 'day_extra', price: 0 })
              pricesTemporadasContrateCar.push({
                category_id: category.category_id.id,
                marca_id: null,
                temporada_id: season.temporada_id,
                from: season.from,
                to: season.to,
                prices: arrTarifN,
                cupos: [{ oficina_id: [-1], cuposDisponible: null, cuposTotal: null }],
              })
            }
          }
        })

        marcasModeloContrateCar.forEach(marca => {
          const prices = pricesTemporadasContrateCar.filter(
            e => e.temporada_id === season.temporada_id && e.marca_id === marca.marca_id,
          )
          if (prices.length === 0) {
            const arrTarif = []
            arrTarif.push({ tarifa_id: 'seguro', price: 0 })
            arrTarif.push({ tarifa_id: 'deposito', price: 0 })
            arrTarif.push({ tarifa_id: 'day_extra', price: 0 })
            season.tarifas_id.forEach(element => {
              arrTarif.push({ tarifa_id: element, price: 0 })
            })
            pricesTemporadasContrateCar.push({
              category_id: null,
              marca_id: marca.marca_id,
              temporada_id: season.temporada_id,
              from: season.from,
              to: season.to,
              prices: arrTarif,
              cupos: [{ oficina_id: [-1], cuposDisponible: null, cuposTotal: null }],
            })
          } else {
            let find = false
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < pricesTemporadasContrateCar.length; index++) {
              const element = pricesTemporadasContrateCar[index]
              if (element.temporada_id === season.temporada_id && element.marca_id === marca.marca_id) {
                // VERIFICAR SI YA EXITIA LA TARIFA
                const tarifaPrice = pricesTemporadasContrateCar[index].prices

                const arrTarif = []
                arrTarif.push({
                  tarifa_id: 'seguro',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'seguro')[0].price,
                })
                arrTarif.push({
                  tarifa_id: 'deposito',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'deposito')[0].price,
                })
                arrTarif.push({
                  tarifa_id: 'day_extra',
                  price: tarifaPrice.filter(e => e.tarifa_id === 'day_extra')[0].price,
                })
                season.tarifas_id.forEach(elementTarif => {
                  const oldPrice = tarifaPrice.filter(e => e.tarifa_id === elementTarif)
                  if (oldPrice.length > 0) {
                    arrTarif.push({ tarifa_id: elementTarif, price: oldPrice[0].price })
                  } else {
                    arrTarif.push({ tarifa_id: elementTarif, price: 0 })
                  }
                })
                const newValue = {
                  category_id: null,
                  marca_id: marca.marca_id,
                  temporada_id: season.temporada_id,
                  from: season.from,
                  to: season.to,
                  prices: arrTarif,
                  cupos: pricesTemporadasContrateCar[index].cupos,
                }

                pricesTemporadasContrateCar[index] = newValue
                find = true
              }
            }
            if (!find) {
              const arrTarifN = []
              arrTarifN.push({ tarifa_id: 'seguro', price: 0 })
              arrTarifN.push({ tarifa_id: 'deposito', price: 0 })
              arrTarifN.push({ tarifa_id: 'day_extra', price: 0 })
              pricesTemporadasContrateCar.push({
                category_id: null,
                marca_id: marca.marca_id,
                temporada_id: season.temporada_id,
                from: season.from,
                to: season.to,
                prices: arrTarifN,
                cupos: [{ oficina_id: [-1], cuposDisponible: null, cuposTotal: null }],
              })
            }
          }
        })
      })
    }
  },
  addCupoPricesTemporadasContrateCar: (state, posPrice) => {
    const { pricesTemporadasContrateCar } = state
    state.cargandoCuposTemporadasContrateCar = true

    pricesTemporadasContrateCar[posPrice].cupos.push({ oficina_id: [-1], cuposDisponible: null, cuposTotal: null })
    setTimeout(() => {
      state.cargandoCuposTemporadasContrateCar = false
    }, 100)
  },
  deleteCupoPricesTemporadasContrateCar: (state, { posPrice, posCupo }) => {
    const { pricesTemporadasContrateCar } = state
    state.cargandoCuposTemporadasContrateCar = true

    pricesTemporadasContrateCar[posPrice].cupos.splice(posCupo, 1)
    setTimeout(() => {
      state.cargandoCuposTemporadasContrateCar = false
    }, 100)
  },
  updatePricesTemporadasContrateCar: (state, items) => {
    state.pricesTemporadasContrateCar = items
  },
  setPosCotizador: (state, pos) => {
    state.posCotizador = pos
  },
  setCotizadorCarsResult: (state, items) => {
    state.cotizadorCarsResult = items
  },
  setCotizadorCars: (state, item) => {
    state.cotizadorCars = item
  },
  setDeclineTerms: (state, value) => {
    state.declineTerms = value
  },
  setSearchingCar: (state, valor) => {
    state.searchingCar = valor
  },
  setCotizadorCarsResultSelect: (state, items) => {
    state.cotizadorCarsResultSelect = items
  },
  setCotizadorCarsResultSelectEdit: (state, items) => {
    state.cotizadorCarsResultSelectEdit = items
  },
  setCotizadorCarsResultSelectEditWith: (state, items) => {
    state.cotizadorCarsResultSelectEditWith = items
  },
  setCotizadorPaxCarSelect: (state, item) => {
    state.cotizadorPaxCarSelect = item
  },
  setSameParamters: (state, value) => {
    state.sameParamters = value
  },
  emptyCotizadorPaxCarSelect: state => {
    state.cotizadorPaxCarSelect = {
      nameConductorPrincipal: null,
      apellidosConductorPrincipal: null,
      nameSecoundConductorPrincipal: null,
      birthdayConductorPrincipal: null,
      nationalityConductorPrincipal: null,
      sexConductorPrincipal: null,
      noDocumentConductorPrincipal: null,
      noDocumentConductorPrincipalScanner: null,
      conductorAditional: false,
      nameConductorAditional: null,
      apellidosConductorAditional: null,
      nameSecoundConductorAditional: null,
      birthdayConductorAditional: null,
      nationalityConductorAditional: null,
      sexConductorAditional: null,
      noDocumentConductorAditional: null,
      noDocumentConductorAditionalScanner: null,
    }
  },
  setCotizadorCarsSelectMarkups: (state, item) => {
    state.cotizadorCarsSelectMarkups = item
  },
  setCotizadorCarSelectPrice: (state, { priceTotal, priceWithMarkup, priceWithDescuento }) => {
    state.cotizadorCarsResultSelect.priceTotal = priceTotal
    state.cotizadorCarsResultSelect.priceWithMarkup = priceWithMarkup
    state.cotizadorCarsResultSelect.priceWithDescuento = priceWithDescuento
  },
  setNoDocumentConductorPrincipalScanner: (state, item) => {
    state.noDocumentConductorPrincipalScanner = item
  },
  setNoDocumentConductorAdicionalScanner: (state, item) => {
    state.noDocumentConductorAditionalScanner = item
  },
  setAvalibleFiltrosCotizadorCar: (state, item) => {
    state.avalibleFiltrosCotizadorCar = item
  },

  updateOnlyAdult: (state, status) => {
    state.onlyAdult = status
  },
  updateAllInclude: (state, status) => {
    state.allInclude = status
  },

  // CONTRATE HOTEL
  addObservationContrateHotel: state => {
    state.observationsHotel.push({
      description: null,
    })
  },
  deleteObservationContrateHotel: (state, pos) => {
    const { observationsHotel } = state

    observationsHotel.splice(pos, 1)
  },
  updateObservationContrateHotel: (state, items) => {
    state.observationsHotel = items
  },

  // HOTELES ASOCIADOS
  addIdsHotelsAsociadosContrate: (state, item) => {
    state.idsHotelsAsociados.push(item)
  },
  deleteIdsHotelsAsociadosContrate: (state, item) => {
    const { idsHotelsAsociados } = state

    const index = idsHotelsAsociados.findIndex(e => e === item)

    idsHotelsAsociados.splice(index, 1)
  },
  updateIdsHotelsAsociadosContrate: (state, items) => {
    state.idsHotelsAsociados = items
  },
  addTemporadaContrateHotel: state => {
    const { temporadasContrateHotel } = state

    temporadasContrateHotel.push({
      temporada_id: uuidv4(),
      name: null,
      typePayment: 'paxByNight',
      showTarifas: false,
      showRooms: false,
      formSGL: {
        type: 'price',
        reduc: '%',
      },
      formTPL: {
        type: 'price',
        reduc: '%',
      },
      formPAX4: {
        type: 'price',
        reduc: '%',
      },
      formPAX5: {
        type: 'price',
        reduc: '%',
      },
      formPAX6: {
        type: 'price',
        reduc: '%',
      },
      formPAX7: {
        type: 'price',
        reduc: '%',
      },
      formPAX8: {
        type: 'price',
        reduc: '%',
      },
      dates: [{ from: null, to: null }],
    })
  },
  deleteTemporadaContrateHotel: (state, pos) => {
    const { temporadasContrateHotel } = state

    temporadasContrateHotel.splice(pos, 1)
  },
  updateTemporadaContrateHotel: (state, update) => {
    state.temporadasContrateHotel = update
  },
  addDateTemporadaContrateHotel: (state, posSeason) => {
    state.temporadasContrateHotel[posSeason].dates.push({ from: null, to: null })
  },
  deleteDateTemporadaContrateHotel: (state, { posSeason, posDate }) => {
    state.temporadasContrateHotel[posSeason].dates.splice(posDate, 1)
  },
  updateIdsHotelsContrateHotel: (state, update) => {
    state.hotelsAsociadosTemporadas = update
  },
  updateHotelesPactadosContrateHotel: (state, update) => {
    state.idsHotelsAsociadosTemporadas = update
  },
  updateCantPaxsContrate: (state, cant) => {
    state.cantPaxsContrate = cant
  },
  addPricesHotelContrate: (state, item) => {
    state.pricesHotelContrate.push(item)
  },
  deletePricesHotelContrate: (state, { contrate_id, hotel_id, room_id }) => {
    const update = []
    state.pricesHotelContrate.forEach(element => {
      // eslint-disable-next-line no-empty
      if (element.contrate_id === contrate_id && element.hotel_id === hotel_id && element.room_id === room_id) {
      } else {
        update.push(element)
      }
    })

    setTimeout(() => {
      state.pricesHotelContrate = update
    }, 150)
  },
  updatePricesHotelContrate: (state, update) => {
    state.pricesHotelContrate = update
  },

  //* ****************************************************************************/
  // contrate hotel
  addSeasonContrateHotel(state, hotel_id) {
    state.seasonsContrateHotel.push({
      hotel_id,
      temporada_id: uuidv4(),
      name: '',
      from: null,
      to: null,
      release: 3,
      estancia_min: 1,
    })

    // actualizar las hab
    if (state.roomsSeasonContrateHotel.length > 0) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < state.roomsSeasonContrateHotel.length; index++) {
        state.roomsSeasonContrateHotel[index].cupos.push({ cupo: 'OR' })
        state.roomsSeasonContrateHotel[index].prices.push({ price: null })
      }
    }

    // actualizar los suplements
    if (state.suplementsSeasonContrateHotel.length > 0) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < state.suplementsSeasonContrateHotel.length; index++) {
        state.suplementsSeasonContrateHotel[index].prices.push({ price: null })
      }
    }
  },
  updateSeasonContrateHotel(state, update) {
    state.seasonsContrateHotel = update
  },
  deleteSeasonContrateHotel(state, pos) {
    state.seasonsContrateHotel.splice(pos, 1)

    // ELIMINAR EN LAS ROOMS
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < state.roomsSeasonContrateHotel.length; index++) {
      state.roomsSeasonContrateHotel[index].cupos.splice(pos, 1)
      state.roomsSeasonContrateHotel[index].prices.splice(pos, 1)
    }

    // ELIMINAR EN LOS SUPLEMENTS
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < state.suplementsSeasonContrateHotel.length; index++) {
      state.suplementsSeasonContrateHotel[index].prices.splice(pos, 1)
    }

    // ELIMINAR EN LAS REDUCCIONES
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < state.reduccionsSeasonContrateHotel.length; index++) {
      state.reduccionsSeasonContrateHotel[index].prices.splice(pos, 1)
    }
  },
  addRoomSeasonContrateHotel(state, plan_id) {
    const cupos = []
    state.seasonsContrateHotel.forEach(() => {
      cupos.push({ cupo: 'OR' })
    })
    const prices = []
    state.seasonsContrateHotel.forEach(() => {
      prices.push({ price: null })
    })
    state.roomsSeasonContrateHotel.push({
      room_id: null,
      plan_id,
      name: null,
      cupos,
      prices,
      max_ocupations: [
        {
          min_pax: 1,
          max_adult: null,
          max_child: null,
          max_pax: null,
        },
      ],
      min_pax: null,
      max_adult: null,
      max_child: null,
      max_pax: null,
    })
  },
  addOcupationRoomSeasonContrateHotel(state, posRoom) {
    state.roomsSeasonContrateHotel[posRoom].max_ocupations.push({
      min_pax: 1,
      max_adult: null,
      max_child: null,
      max_pax: null,
    })
  },
  deleteOcupationRoomSeasonContrateHotel(state, { posRoom, posOcupation }) {
    state.roomsSeasonContrateHotel[posRoom].max_ocupations.splice(posOcupation, 1)
  },
  replicaPlanRoomSeasonContrateHotel(state, { pos, plan_id }) {
    // eslint-disable-next-line no-plusplus
    for (let index = pos + 1; index < state.roomsSeasonContrateHotel.length; index++) {
      state.roomsSeasonContrateHotel[index].plan_id = plan_id
    }
  },
  updateRoomSeasonContrateHotel(state, update) {
    state.roomsSeasonContrateHotel = update
  },
  deleteRoomSeasonContrateHotel(state, pos) {
    state.roomsSeasonContrateHotel.splice(pos, 1)
  },
  addSuplementSeasonContrateHotel(state) {
    const prices = []
    state.seasonsContrateHotel.forEach(() => {
      prices.push({ price: null })
    })

    state.suplementsSeasonContrateHotel = [
      {
        suplement_id: null,
        name: null,
        value: null,
        in_pc: false,
        required: false,
        rooms_id: [],
        prices,
      },
      ...state.suplementsSeasonContrateHotel,
    ]

    /* state.suplementsSeasonContrateHotel.push({
      suplement_id: null,
      name: null,
      value: null,
      in_pc: false,
      required: false,
      rooms_id: [],
      prices,
    }) */
  },
  deleteSuplementSeasonContrateHotel(state, pos) {
    state.suplementsSeasonContrateHotel.splice(pos, 1)
  },
  updateSuplementSeasonContrateHotel(state, update) {
    state.suplementsSeasonContrateHotel = update
  },
  addReduccionSeasonContrateHotel(state) {
    const prices = []
    state.seasonsContrateHotel.forEach(() => {
      prices.push({ price: null })
    })

    state.reduccionsSeasonContrateHotel = [
      {
        reduccion_id: null,
        name: null,
        value: null,
        in_pc: false,
        required: false,
        rooms_id: [],
        prices,
      },
      ...state.reduccionsSeasonContrateHotel,
    ]

    /* state.reduccionsSeasonContrateHotel.push({
      reduccion_id: null,
      name: null,
      value: null,
      in_pc: false,
      required: false,
      rooms_id: [],
      prices,
    }) */
  },
  deleteReduccionSeasonContrateHotel(state, pos) {
    state.reduccionsSeasonContrateHotel.splice(pos, 1)
  },
  updateReduccionSeasonContrateHotel(state, update) {
    state.reduccionsSeasonContrateHotel = update
  },
  updateRangeAgeContrateHotel(state, update) {
    state.rangeAgeContrateHotel = update
  },
  addOfertaSeasonContrateHotel(state) {
    state.ofertasSeasonContrateHotel.push({
      name: null,
      identificador: null,
      fromViaje: null,
      toViaje: null,
      fromReserva: null,
      toReserva: null,
      rooming: null,
      pays: [
        {
          fromPagar: null,
          daysPagar: null,
          valuePagar: null,
          in_pc_pagar: true,
        },
      ],
      datePublic: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdate: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateOld: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateSaved: null,
      dateCancele: null,
      stopSale: false,
      dateStopSale: null,
      modelo: 'descuento',
      calculadoPor: null,
      by_suplement_reductions: false,
      price_by_room: false,
      descuentos: [
        {
          valueDescuento: null,
          in_value_descuento: false,
          rooms_id: [],
        },
      ],
      rooms_by_price: [
        {
          room_id: null,
          price_doble: null,
          price_simple: null,
          price_triple: null,
          price_first_child: null,
          price_second_child: null,
          price_infant: null,
          beneficios: null,
        },
      ],
      rooms_by_price_suplement: [
        {
          room_id: null,
          price_doble: null,
          suplement: [
            {
              suplement_id: null,
              valueSuplement: null,
              in_value_suplement: false,
            },
          ],
          reduction: [
            {
              reduction_id: null,
              valueReduction: null,
              in_value_reduction: false,
            },
          ],
          beneficios: null,
        },
      ],
    })
  },
  deleteOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel.splice(pos, 1)
  },
  updateOfertaSeasonContrateHotel(state, update) {
    state.ofertasSeasonContrateHotel = update
  },
  addOfertaSpecialSeasonContrateHotel(state) {
    state.ofertasSpecialSeasonContrateHotel.push({
      name: null,
      identificador: null,
      fromViaje: null,
      toViaje: null,
      fromReserva: null,
      toReserva: null,
      rooming: null,
      pays: [
        {
          fromPagar: null,
          daysPagar: null,
          valuePagar: null,
          in_pc_pagar: true,
        },
      ],
      datePublic: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdate: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateOld: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateSaved: null,
      dateCancele: null,
      stopSale: false,
      dateStopSale: null,
      modelo: 'descuento',
      calculadoPor: null,
      by_suplement_reductions: false,
      price_by_room: false,
      descuentos: [
        {
          valueDescuento: null,
          in_value_descuento: false,
          rooms_id: [],
        },
      ],
      rooms_by_price: [
        {
          room_id: null,
          price_doble: null,
          price_simple: null,
          price_triple: null,
          price_first_child: null,
          price_second_child: null,
          price_infant: null,
          beneficios: null,
        },
      ],
      rooms_by_price_suplement: [
        {
          room_id: null,
          price_doble: null,
          suplement: [
            {
              suplement_id: null,
              valueSuplement: null,
              in_value_suplement: false,
            },
          ],
          reduction: [
            {
              reduction_id: null,
              valueReduction: null,
              in_value_reduction: false,
            },
          ],
          beneficios: null,
        },
      ],
    })
  },
  confirmDateUpdateStopSaleOfertaSeasonContrateHotel(state, { pos, date }) {
    state.ofertasSeasonContrateHotel[pos].dateUpdateSaved = state.ofertasSeasonContrateHotel[pos].dateUpdateOld
    state.ofertasSeasonContrateHotel[pos].dateUpdateOld = date
  },
  confirmDateUpdateStopSaleOfertaSpecialSeasonContrateHotel(state, { pos, date }) {
    state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateSaved = state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateOld
    state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateOld = date
  },
  cancelDateUpdateStopSaleOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel[pos].dateUpdateOld = state.ofertasSeasonContrateHotel[pos].dateUpdateSaved
    state.ofertasSeasonContrateHotel[pos].dateUpdateSaved = null
  },
  cancelDateUpdateStopSaleOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateOld = state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateSaved
    state.ofertasSpecialSeasonContrateHotel[pos].dateUpdateSaved = null
  },
  updateStopSaleOfertaSeasonContrateHotel(state, { pos, date }) {
    state.ofertasSeasonContrateHotel[pos].dateCancele = date
  },
  updateStopSaleOfertaSpecialSeasonContrateHotel(state, { pos, date }) {
    state.ofertasSpecialSeasonContrateHotel[pos].dateCancele = date
  },
  emptyDescuentosOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel[pos].descuentos = [
      {
        valueDescuento: null,
        in_value_descuento: false,
        rooms_id: [],
      },
    ]
  },
  emptyDescuentosOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].descuentos = [
      {
        valueDescuento: null,
        in_value_descuento: false,
        rooms_id: [],
      },
    ]
  },
  emptyPricesOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price = [
      {
        room_id: null,
        price_doble: null,
        price_simple: null,
        price_triple: null,
        price_first_child: null,
        price_second_child: null,
        price_infant: null,
        beneficios: null,
      },
    ]
  },
  emptyPricesOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price = [
      {
        room_id: null,
        price_doble: null,
        price_simple: null,
        price_triple: null,
        price_first_child: null,
        price_second_child: null,
        price_infant: null,
        beneficios: null,
      },
    ]
  },
  addOfertaSeasonContrateHotelDescuento(state, pos) {
    state.ofertasSeasonContrateHotel[pos].descuentos.push({
      valueDescuento: null,
      in_value_descuento: false,
      rooms_id: [],
    })
  },
  addOfertaSpecialSeasonContrateHotelDescuento(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].descuentos.push({
      valueDescuento: null,
      in_value_descuento: false,
      rooms_id: [],
    })
  },
  deleteOfertaSeasonContrateHotelDescuento(state, { pos, posDesc }) {
    state.ofertasSeasonContrateHotel[pos].descuentos.splice(posDesc, 1)
  },
  deleteOfertaSpecialSeasonContrateHotelDescuento(state, { pos, posDesc }) {
    state.ofertasSpecialSeasonContrateHotel[pos].descuentos.splice(posDesc, 1)
  },
  deleteOfertaSeasonContrateHotelPay(state, { pos, posPay }) {
    state.ofertasSeasonContrateHotel[pos].pays.splice(posPay, 1)
  },
  deleteOfertaSpecialSeasonContrateHotelPay(state, { pos, posPay }) {
    state.ofertasSpecialSeasonContrateHotel[pos].pays.splice(posPay, 1)
  },
  addOfertaSeasonContrateHotelPay(state, pos) {
    state.ofertasSeasonContrateHotel[pos].pays.push({
      fromPagar: null,
      valuePagar: null,
      in_pc_pagar: true,
    })
  },
  addOfertaSpecialSeasonContrateHotelPay(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].pays.push({
      fromPagar: null,
      valuePagar: null,
      in_pc_pagar: true,
    })
  },
  addOfertaSeasonContrateHotelPrice(state, pos) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price.push({
      room_id: null,
      price_doble: null,
      price_simple: null,
      price_triple: null,
      price_first_child: null,
      price_second_child: null,
      price_infant: null,
      beneficios: null,
    })
  },
  addOfertaSpecialSeasonContrateHotelPrice(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price.push({
      room_id: null,
      price_doble: null,
      price_simple: null,
      price_triple: null,
      price_first_child: null,
      price_second_child: null,
      price_infant: null,
      beneficios: null,
    })
  },
  emptyPricesBySuplementOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement = [
      {
        room_id: null,
        price_doble: null,
        suplement: [
          {
            suplement_id: null,
            valueSuplement: null,
            in_value_suplement: false,
          },
        ],
        reduction: [
          {
            reduction_id: null,
            valueReduction: null,
            in_value_reduction: false,
          },
        ],
        beneficios: null,
      },
    ]
  },
  emptyPricesBySuplementOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement = [
      {
        room_id: null,
        price_doble: null,
        suplement: [
          {
            suplement_id: null,
            valueSuplement: null,
            in_value_suplement: false,
          },
        ],
        reduction: [
          {
            reduction_id: null,
            valueReduction: null,
            in_value_reduction: false,
          },
        ],
        beneficios: null,
      },
    ]
  },
  addPricesBySuplementOfertaSeasonContrateHotel(state, pos) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement.push({
      room_id: null,
      price_doble: null,
      suplement: [
        {
          suplement_id: null,
          valueSuplement: null,
          in_value_suplement: false,
        },
      ],
      reduction: [
        {
          reduction_id: null,
          valueReduction: null,
          in_value_reduction: false,
        },
      ],
      beneficios: null,
    })
  },
  addPricesBySuplementOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement.push({
      room_id: null,
      price_doble: null,
      suplement: [
        {
          suplement_id: null,
          valueSuplement: null,
          in_value_suplement: false,
        },
      ],
      reduction: [
        {
          reduction_id: null,
          valueReduction: null,
          in_value_reduction: false,
        },
      ],
      beneficios: null,
    })
  },
  deletePricesBySuplementOfertaSeasonContrateHotel(state, { pos, posPrice }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement.splice(posPrice, 1)
  },
  deletePricesBySuplementOfertaSpecialSeasonContrateHotel(state, { pos, posPrice }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement.splice(posPrice, 1)
  },
  deletePricesBySuplementOfertaSeasonContrateHotelSuplement(state, { pos, posPrice, posSuplement }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].suplement.splice(posSuplement, 1)
  },
  deletePricesBySuplementOfertaSpecialSeasonContrateHotelSuplement(state, { pos, posPrice, posSuplement }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].suplement.splice(posSuplement, 1)
  },
  addPricesBySuplementOfertaSeasonContrateHotelSuplement(state, { pos, posPrice }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].suplement.push({
      suplement_id: null,
      valueSuplement: null,
      in_value_suplement: false,
    })
  },
  addPricesBySuplementOfertaSpecialSeasonContrateHotelSuplement(state, { pos, posPrice }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].suplement.push({
      suplement_id: null,
      valueSuplement: null,
      in_value_suplement: false,
    })
  },
  deletePricesBySuplementOfertaSeasonContrateHotelReduction(state, { pos, posPrice, posReduction }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].reduction.splice(posReduction, 1)
  },
  deletePricesBySuplementOfertaSpecialSeasonContrateHotelReduction(state, { pos, posPrice, posReduction }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].reduction.splice(posReduction, 1)
  },
  addPricesBySuplementOfertaSeasonContrateHotelReduction(state, { pos, posPrice }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].reduction.push({
      reduction_id: null,
      valueReduction: null,
      in_value_reduction: false,
    })
  },
  addPricesBySuplementOfertaSpecialSeasonContrateHotelReduction(state, { pos, posPrice }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price_suplement[posPrice].reduction.push({
      reduction_id: null,
      valueReduction: null,
      in_value_reduction: false,
    })
  },
  deleteOfertaSeasonContrateHotelPrice(state, { pos, posPrice }) {
    state.ofertasSeasonContrateHotel[pos].rooms_by_price.splice(posPrice, 1)
  },
  deleteOfertaSpecialSeasonContrateHotelPrice(state, { pos, posPrice }) {
    state.ofertasSpecialSeasonContrateHotel[pos].rooms_by_price.splice(posPrice, 1)
  },
  deleteOfertaSpecialSeasonContrateHotel(state, pos) {
    state.ofertasSpecialSeasonContrateHotel.splice(pos, 1)
  },
  updateOfertaSpecialSeasonContrateHotel(state, update) {
    state.ofertasSpecialSeasonContrateHotel = update
  },

  //* ***********************************************************************************/

  setShowRoomHotelCotizador: (state, status) => {
    state.showOcupationRoomHotel = status
  },
  addOcupationRoomHotelCotizador: state => {
    state.cotizadorHotels.ocupation.push({
      adults: 2,
      childs: 0,
      edades: [],
      room_id: null,
      plan: null,
      uso: null,
      paxs: [],
      showAllPaxs: false,
      priceTotal: null,
      priceWithMarkups: null,
      priceWithDescuento: null,
    })
  },
  setOcupationHotelShowAll: (state, { pos, value }) => {
    const { cotizadorHotels } = state

    cotizadorHotels.ocupation[pos].showAllPaxs = value
  },
  updateOcupationHotel: (
    state,
    {
      pos, paxs, room_id, plan, uso, priceTotal, priceWithMarkups, priceWithDescuento,
    },
  ) => {
    const { cotizadorHotels } = state

    cotizadorHotels.ocupation[pos] = {
      ...cotizadorHotels.ocupation[pos],
      paxs,
      room_id,
      plan,
      uso,
      priceTotal,
      priceWithMarkups,
      priceWithDescuento,
    }
  },
  updatePlanOcupationHotel: (state, { pos, room_id, plan }) => {
    const { cotizadorHotels } = state

    cotizadorHotels.ocupation[pos] = {
      ...cotizadorHotels.ocupation[pos],
      room_id,
      plan,

      // priceTotal,
      // priceWithMarkups,
      // priceWithDescuento,
    }
  },
  deleteOcupationRoomHotelCotizador: (state, pos) => {
    const { cotizadorHotels } = state

    cotizadorHotels.ocupation.splice(pos, 1)
  },
  setSearchingHotel: (state, valor) => {
    state.searchingHotel = valor
  },
  setCotizadorHotelsResult: (state, items) => {
    state.cotizadorHotelsResult = items
  },
  setCotizadorHotelsResultSelect: (state, items) => {
    state.cotizadorHotelsResultSelect = items
  },
  setCotizadorHotelsSelectMarkups: (state, item) => {
    state.cotizadorHotelsSelectMarkups = item
  },
  setCotizadorHotelSelectPrice: (state, { priceTotal, priceWithMarkup, priceWithDescuento }) => {
    state.cotizadorHotelsResultSelect.priceTotal = priceTotal
    state.cotizadorHotelsResultSelect.priceWithMarkup = priceWithMarkup
    state.cotizadorHotelsResultSelect.priceWithDescuento = priceWithDescuento
  },
  setCotizadorHotelSelectPriceTotal: (state, priceTotal) => {
    state.cotizadorHotelsResultSelect.priceTotal = priceTotal
  },
  setCotizadorHotelsRomms: state => {
    const idBy = []
    state.cotizadorHotelsRomms = []

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < state.cotizadorHotels.ocupation.length; i++) {
      let cont = 1
      let price = state.cotizadorHotels.ocupation[i].priceWithDescuento

      // eslint-disable-next-line no-plusplus
      for (let j = i + 1; j < state.cotizadorHotels.ocupation.length; j++) {
        if (
          state.cotizadorHotels.ocupation[i].room_id === state.cotizadorHotels.ocupation[j].room_id
          && state.cotizadorHotels.ocupation[i].plan === state.cotizadorHotels.ocupation[j].plan
          && state.cotizadorHotels.ocupation[i].uso === state.cotizadorHotels.ocupation[j].uso
          && state.cotizadorHotels.ocupation[i].childs === state.cotizadorHotels.ocupation[j].childs
        ) {
          // eslint-disable-next-line no-plusplus
          cont++
          price += state.cotizadorHotels.ocupation[j].priceWithDescuento
        }
      }

      const concatena = `${state.cotizadorHotels.ocupation[i].room_id}-${state.cotizadorHotels.ocupation[i].plan}-${state.cotizadorHotels.ocupation[i].uso}-${state.cotizadorHotels.ocupation[i].childs}`
      if (!idBy.includes(concatena)) {
        idBy.push(concatena)
        state.cotizadorHotelsRomms.push({
          cant: cont,
          price,
          priceWithDescuento: price,
          room_id: state.cotizadorHotels.ocupation[i].room_id,
          childs: state.cotizadorHotels.ocupation[i].childs,
          plan: state.cotizadorHotels.ocupation[i].plan,
          uso: state.cotizadorHotels.ocupation[i].uso,
        })
      }
    }
  },

  updateDriverAgeCumple: (state, value) => {
    state.driverAgeCumple = value
  },

  // RESERVAS
  updateCommentsGestor: (state, value) => {
    state.comentsGestor = value
  },
  addCommentsGestor: state => {
    state.comentsGestor.push({
      text: null,
    })
  },
  deleteCommentsGestor: (state, pos) => {
    const { comentsGestor } = state

    comentsGestor.splice(pos, 1)
  },
  updateCommentsClient: (state, value) => {
    state.comentsClient = value
  },
  addCommentsClient: state => {
    state.comentsClient.push({
      text: null,
    })
  },
  deleteCommentsClient: (state, pos) => {
    const { comentsClient } = state

    comentsClient.splice(pos, 1)
  },

  // CHATBOT MENSAJES
  adicionarOptionsMessaje: state => {
    const { optionsChatBotMessages } = state
    optionsChatBotMessages.push({ text: null, value: null })
  },
  deleteOptionsMessaje: (state, pos) => {
    const { optionsChatBotMessages } = state

    optionsChatBotMessages.splice(pos, 1)
  },
  updateOptionsMessaje: (state, items) => {
    state.optionsChatBotMessages = items
  },
  setChatActiveAdmin: (state, chat) => {
    state.chatActiveAdmin = chat

    /* if (chat !== null) {
      this.$emit('open-chat', chat.uiiduser)
    } */
  },

  // AFILIADOS
  addContactsAfiliados: state => {
    state.contactsAfiliados.push({
      id: uuidv4(),
      name: null,
      emails: [
        {
          email: null,
        },
      ],
      role_id: null,
      telefonos: [
        {
          ext: null,
          telefono: null,
        },
      ],
      products: [],
    })
  },
  deleteContactsAfiliados: (state, pos) => {
    const { contactsAfiliados } = state

    contactsAfiliados.splice(pos, 1)
  },
  updateContactsAfiliados: (state, items) => {
    state.contactsAfiliados = items
  },
  addEmailContactsAfiliados: (state, pos) => {
    state.contactsAfiliados[pos].emails.push({
      email: null,
    })
  },
  deleteEmailContactsAfiliados: (state, { pos, index }) => {
    const { contactsAfiliados } = state

    contactsAfiliados[index].emails.splice(pos, 1)
  },
  addTelefonoContactsAfiliados: (state, pos) => {
    state.contactsAfiliados[pos].telefonos.push({
      ext: null,
      telefono: null,
    })
  },
  deleteTelefonoContactsAfiliados: (state, { pos, index }) => {
    const { contactsAfiliados } = state

    contactsAfiliados[index].telefonos.splice(pos, 1)
  },

  // MARKUPS
  deleteMarkupsList: (state, pos) => {
    const { markupsList } = state

    markupsList.splice(pos, 1)
  },
  updateMarkupsList: (state, items) => {
    state.markupsList = items
  },

  // RESERVAS
  addEmailAdminReserve: state => {
    state.emailsReserve.push({
      email: null,
    })
  },
  deleteEmailAdminReserve: (state, pos) => {
    const { emailsReserve } = state

    emailsReserve.splice(pos, 1)
  },
  updateEmailAdminReserve: (state, items) => {
    state.emailsReserve = items
  },

  // STOP SALE
  updateStopSales: (state, item) => {
    state.stopSales = item
  },
  updateWatchEvent: (state, value) => {
    state.watchEvent = value
  },
  updateStopSalesPart: (state, parts) => {
    state.stopSales = parts
  },
  deleteStopSalesList: (state, pos) => {
    const { stopSalesList } = state

    stopSalesList.splice(pos, 1)
  },
  updateStopSalesList: (state, items) => {
    state.stopSalesList = items
  },
  addDateStopSale: state => {
    state.datesStopSale.push({
      from: null,
      to: null,
    })
  },
  deleteDateStopSale: (state, pos) => {
    const { datesStopSale } = state

    datesStopSale.splice(pos, 1)
  },
  updateDateStopSale: (state, items) => {
    state.datesStopSale = items
  },

  /** OFERTAS */
  updateOfertEBBList: (state, items) => {
    state.ofertEBBList = items
  },
  updateOfertEBBDates: (state, item) => {
    state.ofertEBBDates = item
  },
  updateOfertEBBDatesOrigin: (state, item) => {
    state.ofertEBBDatesOrigin = item
  },
  initOfertEBB(state) {
    state.ofertEBBDates = {
      identificador: null,
      type_offert: null,
      fromReserva: null,
      toReserva: null,
      rooming: null,
      pays: [
        {
          fromPagar: null,
          daysPagar: null,
          valuePagar: null,
          in_pc_pagar: true,
        },
      ],
      datePublic: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdate: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateOld: new Date(Date.now()).toISOString().substr(0, 10),
      dateUpdateSaved: null,
      dateCancele: null,
      stopSale: false,
      dateStopSale: null,
      modelo: 'precio', // descuento
      calculadoPor: null,
      by_suplement_reductions: false,
      price_by_room: false,
      hotels: [
        {
          hotel_id: null,
          rooms_by_price: [],
          rooms_by_price_suplement: [],
          descuentos: [],
        },
      ],
      historial: [
        {
          action: 'Publicada',
          date: new Date(Date.now()).toISOString().substr(0, 10),
          nameUser: null,
          idUser: null,
        },
      ],

      /* descuentos: [
        {
          valueDescuento: null,
          in_value_descuento: false,
          rooms_id: [],
        },
      ],
      rooms_by_price: [
        {
          room_id: null,
          price_doble: null,
          price_simple: null,
          price_triple: null,
          price_first_child: null,
          price_second_child: null,
          price_infant: null,
          beneficios: null,
        },
      ],
      rooms_by_price_suplement: [
        {
          room_id: null,
          price_doble: null,
          suplement: [
            {
              suplement_id: null,
              valueSuplement: null,
              in_value_suplement: false,
            },
          ],
          reduction: [
            {
              reduction_id: null,
              valueReduction: null,
              in_value_reduction: false,
            },
          ],
          beneficios: null,
        },
      ], */
    }
  },
  asigUserHistorialOfertEBB(state, { nameUser, idUser }) {
    state.ofertEBBDates.historial[state.ofertEBBDates.historial.length - 1].nameUser = nameUser
    state.ofertEBBDates.historial[state.ofertEBBDates.historial.length - 1].idUser = idUser
  },
  emptyOfertEBB(state) {
    state.ofertEBBDates = {}
    state.indexHotelEBB = -1
    state.showHotelEBB = false
    state.indexRoomEBB = -1
    state.showRoomEBB = false
  },
  addHotelOfertEBB(state) {
    state.ofertEBBDates.hotels.push({
      hotel_id: null,
      rooms_by_price: [],
      rooms_by_price_suplement: [],
      descuentos: [],
    })
  },
  deleteHotelOfertEBB(state, pos) {
    state.ofertEBBDates.hotels.splice(pos, 1)
  },
  initDescuentosOfertEBB(state, pos) {
    state.ofertEBBDates.hotels[pos].descuentos = [
      {
        valueDescuento: null,
        in_value_descuento: false,
        rooms_id: [],
        fromViaje: state.ofertEBBDates.fromReserva,
        toViaje: state.ofertEBBDates.toReserva,
        plan_id: null,
      },
    ]
  },
  initRoomByPriceHotelOfertEBB(state, pos) {
    state.ofertEBBDates.hotels[pos].rooms_by_price = [
      {
        room_id: null,
        price_doble: null,
        fromViaje: state.ofertEBBDates.fromReserva,
        toViaje: state.ofertEBBDates.toReserva,
        plan_id: null,
        suplement_reductions: [
          {
            slug: null,
            is_suplement: false,
            suplement_reducc_id: null,
            price: null,
          },
        ],
        show_beneficios: false,
        beneficios: null,
      },
    ]

    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement = [
      {
        room_id: null,
        price_doble: null,
        fromViaje: state.ofertEBBDates.fromReserva,
        toViaje: state.ofertEBBDates.toReserva,
        plan_id: null,
        suplement: [
          {
            suplement_id: null,
            valueSuplement: null,
            in_value_suplement: false,
          },
        ],
        reduction: [
          {
            reduction_id: null,
            valueReduction: null,
            in_value_reduction: false,
          },
        ],
        show_beneficios: false,
        beneficios: null,
      },
    ]
  },
  initAllDescuentosOfertEBB(state) {
    // eslint-disable-next-line no-plusplus
    for (let pos = 0; pos < state.ofertEBBDates.hotels.length; pos++) {
      state.ofertEBBDates.hotels[pos].descuentos = [
        {
          valueDescuento: null,
          in_value_descuento: false,
          rooms_id: [],
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
        },
      ]
    }
  },
  initAllRoomByPriceHotelOfertEBB(state) {
    // eslint-disable-next-line no-plusplus
    for (let pos = 0; pos < state.ofertEBBDates.hotels.length; pos++) {
      state.ofertEBBDates.hotels[pos].rooms_by_price = [
        {
          room_id: null,
          price_doble: null,
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
          suplement_reductions: [
            {
              slug: null,
              is_suplement: false,
              suplement_reducc_id: null,
              price: null,
            },
          ],
          show_beneficios: false,
          beneficios: null,
        },
      ]

      state.ofertEBBDates.hotels[pos].rooms_by_price_suplement = [
        {
          room_id: null,
          price_doble: null,
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
          suplement: [
            {
              suplement_id: null,
              valueSuplement: null,
              in_value_suplement: false,
            },
          ],
          reduction: [
            {
              reduction_id: null,
              valueReduction: null,
              in_value_reduction: false,
            },
          ],
          show_beneficios: false,
          beneficios: null,
        },
      ]
    }
  },
  addRoomByPriceHotelOfertEBB(state, pos) {
    state.ofertEBBDates.hotels[pos].rooms_by_price.push({
      room_id: null,
      price_doble: null,
      fromViaje: state.ofertEBBDates.fromReserva,
      toViaje: state.ofertEBBDates.toReserva,
      plan_id: null,
      suplement_reductions: [
        {
          slug: null,
          is_suplement: false,
          suplement_reducc_id: null,
          price: null,
        },
      ],
      show_beneficios: false,
      beneficios: null,
    })
  },
  deleteRoomByPriceHotelOfertEBB(state, { pos, posRoom }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price.splice(posRoom, 1)
  },
  addSupRedRoomByPriceHotelOfertEBB(state, { pos, posRoom }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price[posRoom].suplement_reductions.push({
      slug: null,
      is_suplement: false,
      suplement_reducc_id: null,
      price: null,
    })
  },
  addDescuentoOfertEBB(state, pos) {
    state.ofertEBBDates.hotels[pos].descuentos.push({
      valueDescuento: null,
      in_value_descuento: false,
      rooms_id: [],
      fromViaje: state.ofertEBBDates.fromReserva,
      toViaje: state.ofertEBBDates.toReserva,
      plan_id: null,
    })
  },
  addRoomByPriceBySuplementHotelOfertEBB(state, pos) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement.push({
      room_id: null,
      price_doble: null,
      fromViaje: state.ofertEBBDates.fromReserva,
      toViaje: state.ofertEBBDates.toReserva,
      plan_id: null,
      suplement: [
        {
          suplement_id: null,
          valueSuplement: null,
          in_value_suplement: false,
        },
      ],
      reduction: [
        {
          reduction_id: null,
          valueReduction: null,
          in_value_reduction: false,
        },
      ],
      show_beneficios: false,
      beneficios: null,
    })
  },
  deleteRoomByPriceBySuplementHotelOfertEBB(state, { pos, posRoom }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement.splice(posRoom, 1)
  },
  addSuplementRoomByPriceBySuplementHotelOfertEBB(state, { pos, posRoom }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement[posRoom].suplement.push({
      suplement_id: null,
      valueSuplement: null,
      in_value_suplement: false,
    })
  },
  deleteSuplementRoomByPriceBySuplementHotelOfertEBB(state, { pos, posRoom, posSup }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement[posRoom].suplement.splice(posSup, 1)
  },
  addReductionRoomByPriceBySuplementHotelOfertEBB(state, { pos, posRoom }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement[posRoom].reduction.push({
      reduction_id: null,
      valueReduction: null,
      in_value_reduction: false,
    })
  },
  deleteReductionRoomByPriceBySuplementHotelOfertEBB(state, { pos, posRoom, posSup }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price_suplement[posRoom].reduction.splice(posSup, 1)
  },
  deleteDescuentoOfertEBB(state, { pos, posDescuento }) {
    state.ofertEBBDates.hotels[pos].descuentos.splice(posDescuento, 1)
  },
  deleteSupRedRoomByPriceHotelOfertEBB(state, { pos, posRoom, posSup }) {
    state.ofertEBBDates.hotels[pos].rooms_by_price[posRoom].suplement_reductions.splice(posSup, 1)
  },
  deleteOfertEBB(state, pos) {
    state.ofertEBBDates.splice(pos, 1)
  },
  updateOfertEBB(state, update) {
    state.ofertEBBDates = update
  },
  deleteOfertPay(state, pos) {
    state.ofertEBBDates.pays.splice(pos, 1)
  },
  addOfertPay(state) {
    state.ofertEBBDates.pays.push({
      fromPagar: null,
      valuePagar: null,
      in_pc_pagar: true,
    })
  },
  updateOfertPay(state, date) {
    state.ofertEBBDates.dateCancele = date
  },
  emptyDescuentosOfertEBB(state) {
    // eslint-disable-next-line no-plusplus
    for (let pos = 0; pos < state.ofertEBBDates.hotels.length; pos++) {
      state.ofertEBBDates.hotels[pos].descuentos = [
        {
          valueDescuento: null,
          in_value_descuento: false,
          rooms_id: [],
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
        },
      ]
    }
  },
  emptyRoomByPriceHotelOfertEBB(state) {
    // eslint-disable-next-line no-plusplus
    for (let pos = 0; pos < state.ofertEBBDates.hotels.length; pos++) {
      state.ofertEBBDates.hotels[pos].rooms_by_price = [
        {
          room_id: null,
          price_doble: null,
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
          suplement_reductions: [
            {
              slug: null,
              is_suplement: false,
              suplement_reducc_id: null,
              price: null,
            },
          ],
          show_beneficios: false,
          beneficios: null,
        },
      ]
    }
  },
  emptyRoomByPriceBySuplementHotelOfertEBB(state) {
    // eslint-disable-next-line no-plusplus
    for (let pos = 0; pos < state.ofertEBBDates.hotels.length; pos++) {
      state.ofertEBBDates.hotels[pos].rooms_by_price_suplement = [
        {
          room_id: null,
          price_doble: null,
          fromViaje: state.ofertEBBDates.fromReserva,
          toViaje: state.ofertEBBDates.toReserva,
          plan_id: null,
          suplement: [
            {
              suplement_id: null,
              valueSuplement: null,
              in_value_suplement: false,
            },
          ],
          reduction: [
            {
              reduction_id: null,
              valueReduction: null,
              in_value_reduction: false,
            },
          ],
          show_beneficios: false,
          beneficios: null,
        },
      ]
    }
  },
  updateShowHotelEBB(state, index) {
    state.showRoomEBB = false
    state.indexRoomEBB = -1
    if (state.indexHotelEBB === -1) {
      state.indexHotelEBB = index
      state.showHotelEBB = true
    } else if (state.indexHotelEBB === index) {
      state.indexHotelEBB = -1
      state.showHotelEBB = false
    } else if (state.indexHotelEBB !== index) {
      state.indexHotelEBB = index
    }
  },
  updateShowRoomEBB(state, index) {
    if (state.indexRoomEBB === -1) {
      state.indexRoomEBB = index
      state.showRoomEBB = true
    } else if (state.indexRoomEBB === index) {
      state.indexRoomEBB = -1
      state.showRoomEBB = false
    } else if (state.indexRoomEBB !== index) {
      state.indexRoomEBB = index
    }
  },

  // CAR SHOP
  adicionarItemToCar(state, item) {
    state.carItems.push(item)
  },
  updateItemToCar(state, items) {
    state.carItems = items
  },
  deleteItemToCar(state, pos) {
    state.carItems.splice(pos, 1)
  },
  emptyClientCarShop: state => {
    state.clientCarShop = {
      name: null,
      apellidos: null,
      email: null,
      subject: null,
      message: null,
      telefono: null,
      is_client_corporate: false,
      id_client_corporate: null,
      id_cta_bancaria: null,
      emails: [],
    }
  },
  setClientCarShop(state, item) {
    state.clientCarShop = item
  },
  updateMessageClientCarShop(state, message) {
    state.clientCarShop.message = message
  },
  updateLoadingBtn(state, loading) {
    state.loadingBtn = loading
  },
  updateIndexCarItem(state, index) {
    state.indexCarItem = index
  },
  updateShowCarItem(state, index) {
    state.showCarItem = index
  },

  setCheckAll(state, value) {
    state.checkAll = value
  },
  addItemCheck(state, item) {
    state.itemsCheck.push(item)
  },
  updateItemCheck(state, arr) {
    state.itemsCheck = arr
  },
  deleteItemCheck(state, pos) {
    state.itemsCheck.splice(pos, 1)
  },
  setCheckAllCobros(state, value) {
    state.checkAllCobros = value
  },
  addItemCheckCobros(state, item) {
    state.itemsCheckCobros.push(item)
  },
  updateItemCheckCobros(state, arr) {
    state.itemsCheckCobros = arr
  },
  deleteItemCheckCobros(state, pos) {
    state.itemsCheckCobros.splice(pos, 1)
  },

  setCheckAllPaysEmit(state, value) {
    state.checkAllPaysEmit = value
  },
  addItemCheckPaysEmit(state, item) {
    state.itemsCheckPaysEmit.push(item)
  },
  updateItemCheckPaysEmit(state, arr) {
    state.itemsCheckPaysEmit = arr
  },
  deleteItemCheckPaysEmit(state, pos) {
    state.itemsCheckPaysEmit.splice(pos, 1)
  },

  setCheckAllPaysRec(state, value) {
    state.checkAllPaysRec = value
  },
  addItemCheckPaysRec(state, item) {
    state.itemsCheckPaysRec.push(item)
  },
  updateItemCheckPaysRec(state, arr) {
    state.itemsCheckPaysRec = arr
  },
  deleteItemCheckPaysRec(state, pos) {
    state.itemsCheckPaysRec.splice(pos, 1)
  },

  // SEASTING
  initSeasting: state => {
    // RESETEAR
    state.seasting.headersLeft = []
    state.seasting.seatsLeft = []
    state.seasting.headersRight = []
    state.seasting.seatsRight = []
    state.seasting.count.columnsLeft = 3
    state.seasting.count.columnsRight = 3
    state.seasting.count.rows = 15

    // HEADERS LEFT
    state.seasting.headersLeft.push({
      name: 'A',
    })
    state.seasting.headersLeft.push({
      name: 'B',
    })
    state.seasting.headersLeft.push({
      name: 'C',
    })

    // HEADERS RIGHT
    state.seasting.headersRight.push({
      name: 'D',
    })
    state.seasting.headersRight.push({
      name: 'E',
    })
    state.seasting.headersRight.push({
      name: 'F',
    })

    for (let row = 0; row < state.seasting.count.rows; row++) {
      // SEAST LEFT
      for (let hLeft = 0; hLeft < state.seasting.headersLeft.length; hLeft++) {
        state.seasting.seatsLeft.push({
          name: null,
          description: null,
          hidden: false,
          disabled: false,
          row: row + 1,
          posHead: hLeft,
        })
      }

      // SEAST RIGHT
      for (let hRight = 0; hRight < state.seasting.headersRight.length; hRight++) {
        state.seasting.seatsRight.push({
          name: null,
          description: null,
          hidden: false,
          disabled: false,
          row: row + 1,
          posHead: hRight,
        })
      }
    }
  },
  setSeasting(state, value) {
    state.seasting = value
  },
  deleteLeftSeasting: (state, posHead) => {
    state.seasting.headersLeft.splice(posHead, 1)

    const newSeats = []
    for (let index = 0; index < state.seasting.seatsLeft.length; index++) {
      if (state.seasting.seatsLeft[index].posHead !== posHead) {
        newSeats.push(state.seasting.seatsLeft[index])
      }
    }
    state.seasting.seatsLeft = newSeats
    state.seasting.count.columnsLeft -= 1
  },
  addLeftSeasting: (state, posHead) => {
    state.seasting.headersLeft.push({
      name: posHead,
    })

    for (let row = 0; row < state.seasting.count.rows; row++) {
      // SEAST LEFT
      state.seasting.seatsLeft.push({
        name: null,
        description: null,
        hidden: false,
        disabled: false,
        row: row + 1,
        posHead: posHead - 1,
      })
    }
    state.seasting.count.columnsLeft += 1
  },
  deleteRightSeasting: (state, posHead) => {
    state.seasting.headersRight.splice(posHead, 1)

    const newSeats = []
    for (let index = 0; index < state.seasting.seatsRight.length; index++) {
      if (state.seasting.seatsRight[index].posHead !== posHead) {
        newSeats.push(state.seasting.seatsRight[index])
      }
    }
    state.seasting.seatsRight = newSeats
    state.seasting.count.columnsRight -= 1
  },
  addRightSeasting: (state, posHead) => {
    state.seasting.headersRight.push({
      name: posHead,
    })

    for (let row = 0; row < state.seasting.count.rows; row++) {
      // SEAST RIGHT
      state.seasting.seatsRight.push({
        name: null,
        description: null,
        hidden: false,
        disabled: false,
        row: row + 1,
        posHead: posHead - 1,
      })
    }
    state.seasting.count.columnsRight += 1
  },
  addRowSeasting: state => {
    state.seasting.count.rows += 1

    // SEAST LEFT
    for (let hLeft = 0; hLeft < state.seasting.headersLeft.length; hLeft++) {
      state.seasting.seatsLeft.push({
        name: null,
        description: null,
        hidden: false,
        disabled: false,
        row: state.seasting.count.rows,
        posHead: hLeft,
      })
    }

    // SEAST RIGHT
    for (let hRight = 0; hRight < state.seasting.headersRight.length; hRight++) {
      state.seasting.seatsRight.push({
        name: null,
        description: null,
        hidden: false,
        disabled: false,
        row: state.seasting.count.rows,
        posHead: hRight,
      })
    }
  },
  deleteRowSeasting: state => {
    // SEATS LEFT
    const newLeftSeats = []
    for (let index = 0; index < state.seasting.seatsLeft.length; index++) {
      if (state.seasting.seatsLeft[index].row !== state.seasting.count.rows) {
        newLeftSeats.push(state.seasting.seatsLeft[index])
      }
    }
    state.seasting.seatsLeft = newLeftSeats

    // SEATS RIGHT
    const newRightSeats = []
    for (let index = 0; index < state.seasting.seatsRight.length; index++) {
      if (state.seasting.seatsRight[index].row !== state.seasting.count.rows) {
        newRightSeats.push(state.seasting.seatsRight[index])
      }
    }
    state.seasting.seatsRight = newRightSeats

    state.seasting.count.rows -= 1
  },

  setFiltrosExport(state, item) {
    state.filtrosExport = item
  },

  updateCMS(state, item) {
    state.textEnriquecido = item
  },

  addCtasBancarias(state) {
    state.ctasBancarias.push({
      id: uuidv4(),
      payments_id: 0,
      payments: 'banco',
      name_fiscal_facturation: null,
      no_cuenta_bancaria: null,
      moneda: null,
      swift: null,
      iban: null,
      name_banco: null,
      code_sucursal: null,
      address: [
        {
          address: null,
        },
      ],
      code_postal: null,
      localidad: null,
      country: null,
      principal: false,
      update_utc: 'automatic',
      utc: null,
      time_utc_public: null,
      time_utc_check: null,
      time_utc_active: null,
      dataZelle: {
        email: null,
        phone: null,
      },
      dataWise: null,
      dataPaypal: null,
      dataRedsys: null,
      dataSIBS: null,
    })
  },
  updateCtasBancarias(state, arr) {
    state.ctasBancarias = arr
  },
  deleteCtasBancarias(state, pos) {
    state.ctasBancarias.splice(pos, 1)
  },
  addAddressCtasBancarias(state, pos) {
    state.ctasBancarias[pos].address.push({
      address: null,
    })
  },
  deleteAddressCtasBancarias(state, { pos, posA }) {
    state.ctasBancarias[pos].address.splice(posA, 1)
  },

  // TARIFARIOS
  updateItemsTarifarios(state, arr) {
    state.itemsTarifarios = arr
  },

  // BANCARIOS
  updateDataBancaria(state, arr) {
    state.dataBancaria = arr
  },
  addAddressDataBancaria(state) {
    state.dataBancaria.info_fiscal.address.push({
      address: null,
    })
  },
  deleteAddressDataBancaria(state, pos) {
    state.dataBancaria.info_fiscal.address.splice(pos, 1)
  },
  setLoadingContent(state, status) {
    state.loadingContent = status
  },
}
